import { AfterViewInit, Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { Apollo } from 'apollo-angular';
import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import ApexCharts from 'apexcharts';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DataService } from '../../../services/data/data.service';
import { CatalogosService } from '../../../services/administrador-gestion/catalogos/catalogos.service';
import { getEvaluaciones, getCuentas, getVars, getVarsTemp, getDetalleEvaluacionCuenta, getDetalleEvaluacionVars, getDetalleEvaluacionVarTemp } from '../../../services/financiero/estados-resultados/querys';
import { FormaterNumberPipe } from '../../../services/pipes/formater-number.pipe';
import { ObtenerIds, indicadores } from '../idsTablas';
import { formulasFunctions } from '../funciones';
import { getDetalleIndicadores, getIndicadores } from '../../../services/financiero/indicadores-financieros/querys';
import { environment } from '../../../../environments/environment';
import { companiesFinanciero } from '../../../shared/catalogos';
import { FiltersM, typesApex } from '../../../components/models';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import { FuncionesMes } from '../../funciones/funcionesGenerales';
import { messages } from '../../funciones/mensajes';
// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);

type FilaCuenta = { id: string; descripcion: string; nivel: number; valores: (number | null)[]; porcentajes: number[] };

type IndicadorReporte = {
  id: string;
  descripcion: string;
  nivel: number;
  formula: string;
  limites: { verde: string; amarillo: string; rojo: string };
  valores: ({ valor: string; semaforo: string } | null)[];
};
type PasoCascada = { nombre: string; tipo: 'total' | 'resta' | 'suma'; valor: number; desde: number; hasta: number };
type BloqueIndicadores = { descripcion: string; indicadores: IndicadorReporte[] };
type ColumnaLimite = { clave: 'verde' | 'amarillo' | 'rojo'; titulo: string; color: string };

@Component({
  selector: 'app-reporte-financiero',
  templateUrl: './reporte-financiero.component.html',
  styleUrl: './reporte-financiero.component.css'
})
export class ReporteFinancieroComponent implements AfterViewInit{
  @ViewChildren(MatSlideToggle, { read: ElementRef }) toggles!: QueryList<ElementRef>;

  public Filtros = FiltersM;
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private idInstitucion: number;
  private idPlantilla: number;

  public cargando = true;
  private evaluacionesInst: { id: number; fechaContable: string }[] = [];

  public miles = ',';
  public decimal = '.';
  public cargandoBalance = false;
  public columnasBalance: { id: number; titulo: string; nombre: string }[] = [];
  public filasBalance: FilaCuenta[] = [];
  /** Filas de nivel 1 y 2 del estado de resultados; los % son sobre los ingresos financieros. */
  public filasEstado: FilaCuenta[] = [];
  public tipoCascada = typesApex.WATERFALL;
  public readonly zonaCostos = 81;
  /** Cascada de estructura de costos: un valor por paso (variación, o total en las posiciones de `totales`) y su nombre. */
  public graficaCostos: { data: any[]; labels: string[]; totales: number[] } = { data: [], labels: [], totales: [] };
  private cascadaCostos: PasoCascada[] = [];
  public textosCostos: string[] = [];
  /** Indicadores agrupados por bloque (protección, estructura financiera, ...), con límites, fórmula y valor y semáforo por periodo. */
  public bloquesDatos: BloqueIndicadores[] = [];
  public columnasLimites: ColumnaLimite[] = [];
  /** Párrafos de análisis que van debajo de la tabla de cada bloque de indicadores, en el mismo orden que `bloquesIndicadores`. */
  public textosBloques: string[][] = [];
  private readonly coloresSemaforo: Record<string, string> = { V: '#72D54A', 'V+': '#72D54A', A: '#FFD100', 'A+': '#FFD100', 'A-': '#FF8300', R: '#FF495C' };
  private readonly clasesSemaforo: Record<string, string> = { V: 'w3-border-verde', 'V+': 'w3-border-verde', A: 'w3-border-amarillo', 'A+': 'w3-border-amarillo', 'A-': 'w3-border-naranja', R: 'w3-border-rojo' };
  public tipoApilada = typesApex.STACKED;
  public readonly zonaTendenciaCostos = 82;
  public graficaTendenciaCostos: { data: any[]; labels: string[] } = { data: [], labels: [] };
  public textosTendenciaCostos: string[] = [];
  private peticionBalance = 0;
  /** Encabezados de cada par de periodos consecutivos, ej. "dic 23 vs dic 24". */
  public paresTendencia: string[] = [];
  /** Párrafos de análisis que van debajo de la tabla de tendencia. */
  public textosTendencia: string[] = [];
  /** Cuentas de cartera (niveles inferiores al 2) con su valor por periodo; alimentan la gráfica y el texto de cartera neta. */
  private cuentasCartera: { id: string; descripcion: string; valores: (number | null)[] }[] = [];
  /** Opciones de ApexCharts de las barras de cartera (se dibujan directo en la vista previa, sin el graficador). */
  public opcionesCartera: any = null;
  public readonly zonaCartera = 80;
  public graficaCartera: { data: any[]; labels: string[] } = { data: [], labels: [] };
  public textosCartera: string[] = [];
  public filasTendencia: { id: string; descripcion: string; nivel: number; valores: (number | null)[]; variaciones: { valor: number | null; porcentaje: number }[] }[] = [];

  public tipoDona = typesApex.DONUT;
  public colorMulti = ['#2843A0', '#15A075', '#36CAE8', '#78EAD2', '#F88476', '#E23E6A'];
  public legendDona = { enabled: true, position: 'bottom' };
  /** Una dona por grupo del balance (activo, pasivo y patrimonio) con el periodo seleccionado. */
  public graficasEstructura: { zona: number; clave: string; bandera: 'activoA' | 'pasivoA' | 'patrimonioA'; dona: 'izquierda' | 'derecha'; data: any[]; labels: string[]; textos: string[] }[] = [];

  /** Cuentas del balance que usan los textos de estructura (ids de la plantilla de financiero). */
  private readonly idsProductivos = { liquidos: 'VT042', inversiones: 'VT048', cartera: 'VT005' };
  private readonly idsCartera = { vigente: 'VT043', mora: 'VT013', previsiones: 'VT014', total: 'VT007' };
  /** Cuentas de costo del estado de resultados y el excedente operativo que usa el texto de estructura de costos. */
  private readonly idsCostos = ['VT036', 'G5110201', 'VT037', 'VT038'];
  /** Cuentas de la tendencia de costos sobre ingresos: las tres de mayor peso, sin las comisiones netas. */
  private readonly idsCostosTendencia = ['VT036', 'G5110201', 'VT037'];
  private readonly idExcedente = 'VT070';
  /**
   * Cuentas de la cascada de estructura de costos, en orden. "total" parte de cero (ingresos, excedente operativo y resultado),
   * "resta" baja el acumulado (costos, previsiones, gastos) y "suma" lo sube (comisiones netas y otros ingresos).
   */
  private readonly pasosCostos: { id: string; tipo: 'total' | 'resta' | 'suma' }[] = [
    { id: 'VT035', tipo: 'total' },
    { id: 'VT036', tipo: 'resta' },
    { id: 'G5110201', tipo: 'resta' },
    { id: 'VT037', tipo: 'resta' },
    { id: 'VT038', tipo: 'suma' },
    { id: 'VT070', tipo: 'total' },
    { id: 'VT071', tipo: 'suma' },
    { id: 'VT072', tipo: 'resta' },
    { id: 'VT029', tipo: 'total' },
  ];
  /** Otros ingresos, otros gastos y resultado del ejercicio del estado de resultados. */
  private readonly idsOtros = { ingresos: 'VT071', gastos: 'VT072', resultado: 'VT029' };
  private readonly idsPatrimonio = { capital: 'P311', reservas: 'P312', resultados: 'P313' };
  private readonly numero = new FormaterNumberPipe();
  public descargando = false;
  public nombreInstitucion = '';
  public aniosDisponibles = [];
  public mesesDisponibles = [];
  private todosLosMeses = [];

  public balanceEstructuraA = true;
  public activoA = true;
  public pasivoA = true;
  public patrimonioA = true;

  public balanceTendenciaA = true;
  public carteraNetaA = true;

  public estadoResultadosA = true;
  public estructuraCostosA = true;
  public tendenciaCostosA = true;

  public indicadoresA = true;
  public bloquesIndicadores = [
    { clave: 'proteccion', definicion: true, activo: true },
    { clave: 'estructura-financiera', definicion: true, activo: true },
    { clave: 'costos-rendimientos', definicion: true, activo: true },
    { clave: 'liquidez', definicion: true, activo: true },
    { clave: 'calidad-activos', definicion: true, activo: true },
    { clave: 'indicador-referencial', definicion: false, activo: true },
    { clave: 'costo-fondeo', definicion: false, activo: true },
  ];

  public conclusionesA = true;
  public textoConclusiones = '';

  /** Colores de las tablas, iguales a los de estados financieros */
  private readonly fondoEncabezado = '#E0E0E0';
  private readonly colorEncabezado = '#616161';
  private readonly colorTexto = '#616161';
  private readonly bordeEncabezado = ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'];
  private readonly azulNivel1 = '#004A98';
  private readonly azulNivel2 = '#2780e0';

  private readonly iconoMas = 'M12 13 4 13 4 11 12 11 12 3 14 3 14 11 22 11V13L14 13 14 21H12L12 13Z';

  constructor(
    public readonly dataService: DataService,
    private readonly apollo: Apollo,
    private readonly cookies: CookieService,
    private readonly catalogos: CatalogosService,
    private readonly translate: TranslateService,
  ){
    this.idInstitucion = Number(cookies.get('idInstitucion'));
    this.idPlantilla = Number(cookies.get('idPlanFin'));
    this.iniciar();
  }

  ngAfterViewInit(): void {
    this.aplicarIconoMas();
    this.toggles.changes.subscribe(() => this.aplicarIconoMas());
  }

  private aplicarIconoMas(){
    this.toggles.forEach(t => {
      const icono = t.nativeElement.querySelector('.mdc-switch__icon--on');
      icono?.firstChild?.setAttribute('d', this.iconoMas);
    });
  }

  private async iniciar(){
    try{
      const config = companiesFinanciero.find(c => c.id === `${this.idInstitucion}`);
      const [institucion, evaluaciones] = await Promise.all([
        firstValueFrom(this.catalogos.getInstitucionesAdmin(config.idAdmin)),
        this.getEvaluaciones(),
      ]);
      this.nombreInstitucion = institucion['company_name'];
      this.evaluacionesInst = evaluaciones;
      this.armarPeriodos(evaluaciones);
      this.cargarTablaBalance();
    }catch(err){
      messages.errorMessageGraph(err?.message ?? err);
    }finally{
      this.cargando = false;
    }
  }

  private async getEvaluaciones(){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getEvaluaciones,
        context: { headers: this.headers },
        variables: { idPlantilla: this.idPlantilla }
      }).valueChanges.source
    );
    return data.evaluaciones.filter(e => e.idInstitucion === this.idInstitucion);
  }

  /** Arma los filtros de año y mes con los periodos que tienen evaluación cargada; deja marcado el más reciente. */
  private armarPeriodos(evaluaciones: any[]){
    const periodos = [...new Set(evaluaciones.map(e => (e.fechaContable as string).substring(0, 7)))].sort();

    const anios = [];
    this.todosLosMeses = [];
    for(const per of periodos){
      const [anio, mes] = per.split('-');
      if(!anios.some(a => a.name === anio)){
        anios.push({ name: anio, value: Number(anio), check: false, selected: false });
      }
      this.todosLosMeses.push({
        name: FuncionesMes.f_switchmes2(mes),
        value: `${anio}${mes}`,
        year: anio,
        check: false,
      });
    }
    if(anios.length === 0){
      return;
    }
    anios[anios.length - 1].check = true;
    this.aniosDisponibles = anios;
    this.mostrarMesesDelAnio(anios[anios.length - 1].name);
  }

  private mostrarMesesDelAnio(anio: string){
    this.mesesDisponibles = this.todosLosMeses.filter(m => m.year === anio);
    this.mesesDisponibles.forEach(m => m.check = false);
    this.mesesDisponibles[this.mesesDisponibles.length - 1].check = true;
  }

  public anioChange(anio: any){
    this.aniosDisponibles.forEach(a => a.check = a.value === anio.value);
    this.mostrarMesesDelAnio(`${anio.value}`);
    this.cargarTablaBalance();
  }

  public mesChange(mes: any){
    this.mesesDisponibles.forEach(m => m.check = m.value === mes.value);
    this.cargarTablaBalance();
  }

  private get mesSeleccionado(){
    return this.mesesDisponibles.find(m => m.check);
  }

  /** Ej. "julio 2025"; vacío mientras no hay periodos. */
  public get periodoTexto(): string{
    const mes = this.mesSeleccionado;
    if(!mes){
      return '';
    }
    return `${FuncionesMes.f_switchmes(mes.value.substring(4, 6))} ${mes.year}`;
  }

  /** Ej. "julio"; el estado de resultados del periodo es acumulado de enero a este mes. */
  private get mesTexto(): string{
    const mes = this.mesSeleccionado;
    return mes ? FuncionesMes.f_switchmes(mes.value.substring(4, 6)) : '';
  }

  /** Años anteriores al seleccionado que sí existen en la base de datos, de menor a mayor. */
  public get aniosPrevios(): number[]{
    const mes = this.mesSeleccionado;
    if(!mes){
      return [];
    }
    return this.aniosDisponibles
      .map(a => a.value as number)
      .filter(a => a < Number(mes.year))
      .sort((a, b) => a - b);
  }

  /** Ej. "2023, 2024, 2025". */
  public get aniosPreviosTexto(): string{
    return this.aniosPrevios.join(', ');
  }

  public get claveTituloAnalisis(): string{
    return this.aniosPrevios.length > 0 ? 'analisis-financiero-titulo' : 'analisis-financiero-titulo-sin';
  }

  public get claveIntroAnalisis(): string{
    switch(this.aniosPrevios.length){
      case 0: return 'analisis-financiero-intro-sin';
      case 1: return 'analisis-financiero-intro-uno';
      default: return 'analisis-financiero-intro';
    }
  }

  /** Ej. "diciembre 2023 y diciembre 2024": los cierres previos contra los que se contrasta el periodo. */
  private get cierresPreviosTexto(): string{
    const nombres = this.columnasBalance.slice(0, -1).map(c => c.nombre);
    if(nombres.length < 2){
      return nombres.join('');
    }
    return `${nombres.slice(0, -1).join(', ')} y ${nombres[nombres.length - 1]}`;
  }

  /** Ej. "dos"; cae al número cuando son más de diez. */
  private get cantidadPreviosTexto(): string{
    const palabras = ['cero', 'un', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez'];
    return palabras[this.aniosPrevios.length] ?? `${this.aniosPrevios.length}`;
  }

  public get parametrosReporte(){
    return {
      institucion: this.nombreInstitucion,
      periodo: this.periodoTexto,
      anios: this.aniosPreviosTexto,
      cantidad: this.aniosPrevios.length,
      mes: this.mesTexto,
      cantidadTexto: this.cantidadPreviosTexto,
      cierres: this.cierresPreviosTexto,
    };
  }

  /* ------------------------ Balance general | estructura ------------------------ */
  /** Cierre de cada año previo (su última evaluación) y el periodo seleccionado, de menor a mayor. */
  private evaluacionesColumnas(): { id: number; titulo: string; nombre: string }[]{
    const sel = this.mesSeleccionado;
    if(!sel){
      return [];
    }
    const porFecha = [...this.evaluacionesInst].sort((a, b) => a.fechaContable.localeCompare(b.fechaContable));
    const titulo = (fecha: string) => {
      const [anio, mes] = fecha.substring(0, 7).split('-');
      return `${this.translate.instant('filtros.' + FuncionesMes.f_switchmes2(mes))} ${anio.substring(2)}`;
    };

    // Ej. "diciembre 2023", para los textos
    const nombre = (fecha: string) => {
      const [anio, mes] = fecha.substring(0, 7).split('-');
      return `${FuncionesMes.f_switchmes(mes)} ${anio}`;
    };

    const columnas = [];
    for(const anio of this.aniosPrevios){
      const cierre = porFecha.filter(e => e.fechaContable.startsWith(`${anio}-`)).pop();
      if(cierre){
        columnas.push({ id: cierre.id, titulo: titulo(cierre.fechaContable), nombre: nombre(cierre.fechaContable) });
      }
    }
    const periodo = `${sel.year}-${sel.value.substring(4, 6)}`;
    const actual = porFecha.filter(e => e.fechaContable.startsWith(periodo)).pop();
    if(actual){
      columnas.push({ id: actual.id, titulo: titulo(actual.fechaContable), nombre: nombre(actual.fechaContable) });
    }
    return columnas;
  }

  private async cargarTablaBalance(){
    const peticion = ++this.peticionBalance;
    this.cargandoBalance = true;
    try{
      const columnas = this.evaluacionesColumnas();
      const [resultado, indicadoresCargados] = await Promise.all([
        columnas.length > 0
          ? this.obtenerFilasBalance(columnas)
          : Promise.resolve({ filas: [] as FilaCuenta[], cartera: [] as { id: string; descripcion: string; valores: (number | null)[] }[], estado: [] as FilaCuenta[] }),
        columnas.length > 0
          ? this.obtenerIndicadores(columnas)
          : Promise.resolve({ bloques: [] as BloqueIndicadores[], limites: [] as ColumnaLimite[] }),
      ]);
      const { filas, cartera, estado } = resultado;
      if(peticion === this.peticionBalance){
        this.columnasBalance = columnas;
        this.filasBalance = filas;
        this.cuentasCartera = cartera;
        this.filasEstado = estado;
        this.bloquesDatos = indicadoresCargados.bloques;
        this.columnasLimites = indicadoresCargados.limites;
        this.armarGraficasEstructura();
        this.armarTendencia();
        this.armarCartera();
        this.armarTextosIndicadores();
        this.armarGraficaCostos();
      }
    }catch(err){
      if(peticion === this.peticionBalance){
        messages.errorMessageGraph(err?.message ?? err);
      }
    }finally{
      if(peticion === this.peticionBalance){
        this.cargandoBalance = false;
      }
    }
  }

  /**
   * Arma una dona por cada fila de nivel 1 (activo, pasivo y patrimonio) con sus cuentas de nivel 2 del periodo seleccionado.
   * El porcentaje va en la etiqueta para que la leyenda lo muestre fijo debajo de la gráfica.
   */
  private armarGraficasEstructura(){
    type Cuenta = { id: string; descripcion: string; valor: number };
    const grupos: { titulo: string; total: number; cuentas: Cuenta[] }[] = [];
    const ultima = this.columnasBalance.length - 1;
    for(const fila of this.filasBalance){
      const valor = fila.valores[ultima] ?? 0;
      if(fila.nivel === 1){
        grupos.push({ titulo: fila.descripcion, total: valor, cuentas: [] });
      }else if(grupos.length > 0 && valor > 0){
        grupos[grupos.length - 1].cuentas.push({ id: fila.id, descripcion: fila.descripcion, valor });
      }
    }
    const totalActivo = grupos[0]?.total ?? 0;
    const pct = (valor: number) => this.formatoNumero(totalActivo === 0 ? 0 : (valor / totalActivo) * 100, 1);
    const monto = (valor: number) => this.formatoNumero(valor);
    const cuenta = (g: typeof grupos[number], id: string) => g?.cuentas.find(c => c.id === id)?.valor ?? 0;
    const periodo = this.periodoTexto;

    const textoActivo = (g: typeof grupos[number]) => {
      const { liquidos, inversiones, cartera } = this.idsProductivos;
      const productivos = cuenta(g, liquidos) + cuenta(g, inversiones) + cuenta(g, cartera);
      const porcentaje = totalActivo === 0 ? 0 : (productivos / totalActivo) * 100;
      const estado = porcentaje >= 90 ? 'equilibrada' : porcentaje >= 80 ? 'ligeramente' : 'desequilibrada';
      return [
        this.t('estructura-activo-texto-1', { periodo, total: monto(totalActivo) }),
        this.t('estructura-activo-texto-2', {
          productivos: this.formatoNumero(porcentaje, 1),
          estado: this.t(`estructura-activo-${estado}`),
        }),
        this.t('estructura-activo-texto-3', {
          liquidos: pct(cuenta(g, liquidos)),
          inversiones: pct(cuenta(g, inversiones)),
          cartera: pct(cuenta(g, cartera)),
        }),
      ];
    };
    const textoPasivo = (g: typeof grupos[number], patrimonio: typeof grupos[number]) => {
      const porcentaje = totalActivo === 0 ? 0 : (g.total / totalActivo) * 100;
      const estado = porcentaje >= 70 && porcentaje <= 80 ? 'equilibrio' : porcentaje > 90 ? 'desequilibrio' : 'ligero';
      const [mayor, segunda] = [...g.cuentas].sort((a, b) => b.valor - a.valor);
      const pctPasivo = (valor: number) => this.formatoNumero(g.total === 0 ? 0 : (valor / g.total) * 100, 0);
      return [
        this.t('estructura-pasivo-texto-1', {
          estado: this.t(`estructura-pasivo-${estado}`),
          periodo,
          pasivos: pct(g.total),
          patrimonio: pct(patrimonio?.total ?? 0),
        }),
        ...(mayor ? [this.t('estructura-pasivo-texto-2', {
          total: monto(g.total),
          cuenta: mayor.descripcion.toLowerCase(),
          saldo: monto(mayor.valor),
          porcentaje: pct(mayor.valor),
          porcentajePasivo: pctPasivo(mayor.valor),
          siguiente: segunda ? this.t('estructura-pasivo-seguidas', {
            cuenta: segunda.descripcion.toLowerCase(),
            porcentajePasivo: pctPasivo(segunda.valor),
          }) : '',
        })] : []),
      ];
    };
    const textoPatrimonio = (g: typeof grupos[number]) => {
      const { capital, reservas, resultados } = this.idsPatrimonio;
      return [
        this.t('estructura-patrimonio-texto', {
          capital: pct(cuenta(g, capital)),
          capitalMonto: monto(cuenta(g, capital)),
          reservas: pct(cuenta(g, reservas)),
          reservasMonto: monto(cuenta(g, reservas)),
          resultados: pct(cuenta(g, resultados)),
          resultadosMonto: monto(cuenta(g, resultados)),
        }),
      ];
    };
    const textos = [
      grupos[0] ? textoActivo(grupos[0]) : [],
      grupos[1] ? textoPasivo(grupos[1], grupos[2]) : [],
      grupos[2] ? textoPatrimonio(grupos[2]) : [],
    ];
    const claves = [
      { clave: 'estructura-activo', bandera: 'activoA' as const },
      { clave: 'estructura-pasivo', bandera: 'pasivoA' as const },
      { clave: 'estructura-patrimonio', bandera: 'patrimonioA' as const },
    ];
    this.graficasEstructura = grupos.slice(0, claves.length).map((g, i) => {
      const total = g.cuentas.reduce((suma, c) => suma + c.valor, 0);
      return {
        zona: 71 + i,
        ...claves[i],
        dona: i % 2 === 0 ? 'izquierda' as const : 'derecha' as const,
        textos: textos[i],
        data: [{ name: g.titulo, data: g.cuentas.map(c => c.valor) }],
        labels: g.cuentas.map(c => `${c.descripcion} (${this.formatoNumero((c.valor / total) * 100, 1)}%)`),
      };
    });
  }

  /** Variación en monto y en % de cada cuenta entre periodos consecutivos (análisis horizontal). */
  private armarTendencia(){
    const columnas = this.columnasBalance;
    this.paresTendencia = columnas.slice(1).map((c, i) => `${columnas[i].titulo} vs ${c.titulo}`);
    this.filasTendencia = this.filasBalance.map(f => ({
      id: f.id,
      descripcion: f.descripcion,
      nivel: f.nivel,
      valores: f.valores,
      variaciones: f.valores.slice(1).map((actual, i) => {
        const previo = f.valores[i];
        if(previo === null || actual === null){
          return { valor: null, porcentaje: 0 };
        }
        return { valor: actual - previo, porcentaje: previo === 0 ? 0 : ((actual - previo) / Math.abs(previo)) * 100 };
      }),
    }));
    this.armarTextosTendencia();
  }

  /**
   * Gráfica de barras con cartera bruta vigente, mora mayor a 60 días y previsiones como % de la cartera total (VT007, cartera bruta;
   * si la plantilla no la trae, vigente más mora), y los textos de cartera, pasivos y patrimonio.
   * Variación total = último periodo menos el primero; el resto se toma de las variaciones entre periodos consecutivos.
   */
  private armarCartera(){
    this.textosCartera = [];
    const columnas = this.columnasBalance;
    const orden = [this.idsCartera.vigente, this.idsCartera.mora, this.idsCartera.previsiones];
    const series = orden.map(id => this.cuentasCartera.find(c => c.id === id)).filter(c => !!c);
    const cuentaTotal = this.cuentasCartera.find(c => c.id === this.idsCartera.total);
    const valorDe = (id: string, i: number) => this.cuentasCartera.find(c => c.id === id)?.valores[i] ?? 0;
    const totalCartera = (i: number) => cuentaTotal ? (cuentaTotal.valores[i] ?? 0) : valorDe(this.idsCartera.vigente, i) + valorDe(this.idsCartera.mora, i);
    this.graficaCartera = {
      data: series.map(c => ({
        name: c.descripcion,
        data: c.valores.map((v, i) => totalCartera(i) === 0 ? 0 : Number((((v ?? 0) / totalCartera(i)) * 100).toFixed(2))),
      })),
      labels: columnas.map(c => c.titulo),
    };
    this.opcionesCartera = this.graficaCartera.data.length > 0 ? this.opcionesBarrasCartera(false) : null;
    if(columnas.length < 2){
      return;
    }
    const ultima = columnas.length - 1;
    const desde = columnas[0].nombre;
    const hasta = columnas[ultima].nombre;
    const vigente = this.cuentasCartera.find(c => c.id === this.idsCartera.vigente);
    const mora = this.cuentasCartera.find(c => c.id === this.idsCartera.mora);
    const niveles1 = this.filasTendencia.filter(f => f.nivel === 1);
    const pasivo = niveles1[1];
    const patrimonio = niveles1[2];
    const par = (i: number) => ({ desde: columnas[i].nombre, hasta: columnas[i + 1].nombre });

    if(vigente){
      const inicial = vigente.valores[0] ?? 0;
      const final = vigente.valores[ultima] ?? 0;
      this.textosCartera.push(this.t('cartera-texto-vigente', {
        tendencia: this.t(final >= inicial ? 'cartera-creciente' : 'cartera-decreciente'),
        inicial: this.formatoNumero(inicial),
        final: this.formatoNumero(final),
        porcentaje: this.formatoNumero(inicial === 0 ? 0 : ((final - inicial) / Math.abs(inicial)) * 100, 1),
        desde,
        hasta,
      }));
    }
    if(mora){
      const inicial = mora.valores[0] ?? 0;
      const final = mora.valores[ultima] ?? 0;
      this.textosCartera.push(this.t('cartera-texto-mora', {
        tendencia: this.t(final >= inicial ? 'tendencia-alza' : 'tendencia-baja'),
        sentido: this.t(final >= inicial ? 'cartera-crecimiento' : 'cartera-decremento'),
        porcentaje: this.formatoNumero(inicial === 0 ? 0 : (Math.abs(final - inicial) / Math.abs(inicial)) * 100, 1),
        variacion: this.formatoNumero(final - inicial),
        desde,
        hasta,
      }));
    }
    if(pasivo){
      const clausulas = pasivo.variaciones.map((v, i) => this.t(
        `cartera-pasivos-${i === 0 ? 'primero' : 'siguiente'}-${(v.valor ?? 0) >= 0 ? 'sube' : 'baja'}`,
        { ...par(i), porcentaje: this.formatoNumero(Math.abs(v.porcentaje), 1) }
      ));
      this.textosCartera.push(this.t('cartera-texto-pasivos', {
        detalle: this.enumerar(clausulas),
        total: this.formatoNumero((pasivo.valores[ultima] ?? 0) - (pasivo.valores[0] ?? 0)),
        porcentaje: this.formatoNumero((pasivo.valores[0] ?? 0) === 0 ? 0 : (((pasivo.valores[ultima] ?? 0) - (pasivo.valores[0] ?? 0)) / Math.abs(pasivo.valores[0] ?? 0)) * 100, 1),
      }));
    }
    if(patrimonio){
      // Si el tramo anterior ya dijo "registró un…", el siguiente omite el verbo para no repetirlo
      const repiteRegistro = (i: number) => i > 0 && (i > 1 || (patrimonio.variaciones[0].valor ?? 0) < 0);
      const clausulas = patrimonio.variaciones.map((v, i) => this.t(
        i === 0 ? 'cartera-patrimonio-primero' : 'cartera-patrimonio-siguiente',
        {
          ...par(i),
          verbo: this.t('cartera-patrimonio-verbo-' + ((v.valor ?? 0) >= 0 ? (i === 0 ? 'primero-sube' : 'sube') : 'baja') + (repiteRegistro(i) ? '-corto' : '')),
          variacion: this.formatoNumero(v.valor),
          porcentaje: this.formatoNumero(v.porcentaje),
        }
      ));
      this.textosCartera.push(this.t('cartera-texto-patrimonio', { detalle: this.enumerar(clausulas) }));
    }
  }

  /**
   * Indicadores del periodo y de los cierres previos, igual que en Indicadores financieros: mismo orden, mismos límites por color
   * (verde, amarillo y rojo) y el semáforo que calcula el sistema para cada valor. Se muestran los límites tal como están en la plantilla.
   */
  private async obtenerIndicadores(columnas: { id: number }[]){
    const idPlantilla = this.idPlantilla;
    const [definiciones, detalles] = await Promise.all([
      this.consultar(getIndicadores, { idPlantilla }, 'indicadores'),
      Promise.all(columnas.map(c => this.consultar(getDetalleIndicadores, { idEvaluacion: c.id }, 'detalleEvaluacionIndicadors'))),
    ]);

    let datos: any[] = definiciones;
    if([5, 8, 12, 13].includes(idPlantilla)){
      const orden = idPlantilla === 5 ? indicadores.indiFinancieros5
        : idPlantilla === 12 ? indicadores.indiFinancierosA
        : idPlantilla === 13 ? indicadores.indiFinancieros13
        : indicadores.indiFinancieros;
      let ordenados: any[] = [];
      for(const ind of orden){
        const macro = datos.find(c => c.id === ind.name);
        if(macro){
          const sub = datos
            .filter(c => c.id.includes(macro.id) && c.nivel === 3)
            .sort((a, b) => Number(a.id.split(macro.id)[1]) - Number(b.id.split(macro.id)[1]));
          ordenados = ordenados.concat(macro, sub);
        }
      }
      datos = ordenados;
    }

    const excluidos = ['EMP', 'GESTION'];
    const porEvaluacion = detalles.map(lista => new Map<string, any>(lista.map((d: any) => [d.idIndicador, d])));
    const bloques: BloqueIndicadores[] = [];
    for(const def of datos){
      if(excluidos.includes(def.id) || def.idPlantilla !== idPlantilla || !porEvaluacion.some(m => m.has(def.id))){
        continue;
      }
      const nivel = def.nivel - 1;
      if(nivel === 1 || bloques.length === 0){
        bloques.push({ descripcion: nivel === 1 ? def.descripcion : '', indicadores: [] });
        if(nivel === 1){
          continue;
        }
      }
      bloques[bloques.length - 1].indicadores.push({
        id: def.id,
        descripcion: def.descripcion,
        nivel,
        formula: def.formula ?? '',
        limites: {
          verde: formulasFunctions.formulas(def, 5),
          amarillo: formulasFunctions.formulas(def, 2),
          rojo: formulasFunctions.formulas(def, 0),
        },
        valores: porEvaluacion.map(m => {
          const d = m.get(def.id);
          return d ? { valor: Number(d.valor).toFixed(2), semaforo: d.textoSemaforo } : null;
        }),
      });
    }

    const todos = bloques.flatMap(b => b.indicadores);
    // Los colores son los de las columnas de límites del tablero de Indicadores financieros
    const limites: ColumnaLimite[] = ([
      { clave: 'verde', clavePlantilla: 'titulo2Tabla', color: '#72D54A' },
      { clave: 'amarillo', clavePlantilla: 'titulo5Tabla', color: '#FFD100' },
      { clave: 'rojo', clavePlantilla: 'titulo7Tabla', color: '#FF495C' },
    ] as const)
      .filter(c => todos.some(i => i.limites[c.clave] !== ''))
      .map(c => ({ clave: c.clave, color: c.color, titulo: this.translate.instant(`financiero.razonesFinancieras.${c.clavePlantilla}`) }));
    return { bloques, limites };
  }

  /** Semáforo del sistema (V, V+, A, A+, A-, R) a los tres colores que tienen frase; el naranja usa la del amarillo. */
  private colorFrase(semaforo: string | undefined): 'verde' | 'amarillo' | 'rojo' | null{
    switch(semaforo){
      case 'V':
      case 'V+':
        return 'verde';
      case 'A':
      case 'A+':
      case 'A-':
        return 'amarillo';
      case 'R':
        return 'rojo';
      default:
        return null;
    }
  }

  private normalizar(texto: string): string{
    return texto.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  /** Verdadero si el indicador tiene dos o más periodos con dato y el semáforo tuvo el mismo color en todos. */
  private mismoColorEnPeriodos(indicador: IndicadorReporte): boolean{
    const colores = indicador.valores.filter(v => !!v).map(v => this.colorFrase(v.semaforo));
    return colores.length >= 2 && colores.every(c => c === colores[0]);
  }

  /** "en todos los periodos analizados" si el color fue el mismo en todos los periodos con dato; si no, "a septiembre 2026". */
  private alcanceIndicador(indicador: IndicadorReporte, claveTodos = 'indicadores-alcance-todos'): string{
    return this.mismoColorEnPeriodos(indicador)
      ? this.t(claveTodos)
      : this.t('indicadores-alcance-ultimo', { periodo: this.columnasBalance[this.columnasBalance.length - 1].nombre });
  }

  /** ", en todos los periodos analizados" si el color fue el mismo en todos los periodos; si no, vacío (el texto ya cita el periodo). */
  private alcanceTodosIndicador(indicador: IndicadorReporte): string{
    return this.mismoColorEnPeriodos(indicador) ? `, ${this.t('indicadores-alcance-todos')}` : '';
  }

  /**
   * Frases de los indicadores por bloque (Protección, Estructura financiera, Costos y rendimientos, Liquidez, Calidad de activos e Indicador referencial). La palabra sale del semáforo del último
   * periodo, la tendencia de comparar con el periodo anterior y el alcance de si el color cambió entre periodos.
   */
  private armarTextosIndicadores(){
    this.textosBloques = this.bloquesIndicadores.map(() => []);
    this.armarTextosProteccion();
    this.armarTextosEstructuraFinanciera();
    this.armarTextosCostosRendimientos();
    this.armarTextosLiquidez();
    this.armarTextosCalidadActivos();
    this.armarTextosIndicadorReferencial();
    this.armarTextosCostoFondeo();
  }

  /** Protección: suficiencia de previsiones para cartera, para otros activos de riesgo y solvencia patrimonial. */
  private armarTextosProteccion(){
    const proteccion = this.bloquesDatos[0];
    if(!proteccion || this.columnasBalance.length === 0){
      return;
    }
    const buscar = (condicion: (descripcion: string) => boolean) =>
      proteccion.indicadores.find(i => condicion(this.normalizar(i.descripcion)));
    const colorUltimo = (i: IndicadorReporte) => this.colorFrase(i.valores[i.valores.length - 1]?.semaforo);

    const cartera = buscar(d => d.includes('prev') && d.includes('cartera'));
    const otros = buscar(d => d.includes('prev') && d.includes('otros activos'));
    const solvencia = buscar(d => d.includes('solvencia'));

    const ultima = this.columnasBalance.length - 1;
    const periodo = this.columnasBalance[ultima].nombre;
    const valor = (i: IndicadorReporte) => i.valores[ultima]?.valor;

    const textos: string[] = [];
    if(cartera && colorUltimo(cartera)){
      textos.push(this.t('indicadores-prev-cartera', {
        cobertura: this.t(`indicadores-cobertura-${colorUltimo(cartera)}`),
        valor: valor(cartera),
        periodo,
        alcance: this.alcanceTodosIndicador(cartera),
      }));
    }
    if(otros && colorUltimo(otros)){
      textos.push(this.t('indicadores-prev-otros', {
        cobertura: this.t(`indicadores-cobertura-${colorUltimo(otros)}`),
        valor: valor(otros),
        alcance: this.alcanceIndicador(otros),
      }));
    }
    if(solvencia && colorUltimo(solvencia)){
      textos.push(this.t('indicadores-solvencia', {
        patrimonio: this.t(`indicadores-solvencia-patrimonio-${colorUltimo(solvencia)}`),
        valor: valor(solvencia),
        posicion: this.t(`indicadores-solvencia-posicion-${colorUltimo(solvencia)}`),
        alcance: this.alcanceIndicador(solvencia),
      }));
    }
    this.textosBloques[0] = textos;
  }

  /**
   * Estructura financiera: participación de cartera; financiamiento de activos con endeudamiento y con patrimonio (un solo párrafo);
   * y límite a captaciones individuales.
   */
  private armarTextosEstructuraFinanciera(){
    const bloque = this.bloquesDatos[1];
    if(!bloque || this.columnasBalance.length === 0){
      return;
    }
    const ultima = this.columnasBalance.length - 1;
    const periodo = this.columnasBalance[ultima].nombre;
    const buscar = (condicion: (descripcion: string) => boolean) =>
      bloque.indicadores.find(i => condicion(this.normalizar(i.descripcion)));
    const valor = (i: IndicadorReporte, posicion: number) => i.valores[posicion] ? Number(i.valores[posicion].valor) : null;
    const texto = (i: IndicadorReporte, posicion: number) => i.valores[posicion]?.valor;
    const colorUltimo = (i: IndicadorReporte) => this.colorFrase(i.valores[ultima]?.semaforo);

    const participacion = buscar(d => d.includes('participacion') && d.includes('cartera'));
    const endeudamiento = buscar(d => d.includes('financiamiento') && d.includes('endeudamiento'));
    const patrimonio = buscar(d => d.includes('financiamiento') && d.includes('patrimonio'));
    const captaciones = buscar(d => d.includes('captaciones') && d.includes('individuales'));

    const textos: string[] = [];

    if(participacion && colorUltimo(participacion)){
      const anterior = ultima > 0 ? texto(participacion, ultima - 1) : undefined;
      const parametros = {
        nivel: this.t(`indicadores-participacion-${colorUltimo(participacion)}`),
        valor: texto(participacion, ultima),
        periodo,
        anterior,
        cambio: this.t((valor(participacion, ultima) ?? 0) >= (valor(participacion, ultima - 1) ?? 0) ? 'indicadores-cambio-incremento' : 'indicadores-cambio-decremento'),
      };
      textos.push(this.t(anterior !== undefined ? 'indicadores-participacion' : 'indicadores-participacion-sin-anterior', parametros));
    }

    if(endeudamiento && patrimonio && colorUltimo(endeudamiento) && patrimonio.valores[ultima]){
      const hayAnterior = ultima > 0 && !!endeudamiento.valores[ultima - 1] && !!patrimonio.valores[ultima - 1];
      const sube = (i: IndicadorReporte) => (valor(i, ultima) ?? 0) >= (valor(i, ultima - 1) ?? 0);
      textos.push(this.t(hayAnterior ? 'indicadores-endeudamiento' : 'indicadores-endeudamiento-sin-anterior', {
        estado: this.t(`indicadores-endeudamiento-${colorUltimo(endeudamiento)}`),
        periodo,
        endeudamiento: texto(endeudamiento, ultima),
        patrimonio: texto(patrimonio, ultima),
        cambio: this.t(sube(endeudamiento) ? 'indicadores-endeudamiento-sube' : 'indicadores-endeudamiento-baja'),
        tendencia: this.t(sube(patrimonio) ? 'indicadores-patrimonio-sube' : 'indicadores-patrimonio-baja'),
      }));
    }

    if(captaciones && colorUltimo(captaciones)){
      textos.push(this.t('indicadores-captaciones', {
        valor: texto(captaciones, ultima),
        periodo,
        verbo: this.t(`indicadores-captaciones-verbo-${colorUltimo(captaciones)}`),
        color: this.t(`indicadores-color-${colorUltimo(captaciones)}`),
        alcance: this.alcanceIndicador(captaciones),
      }));
    }
    this.textosBloques[1] = textos;
  }

  /** Sentido de los valores de un indicador a lo largo de los periodos con dato: sube, baja o varía. */
  private sentidoIndicador(indicador: IndicadorReporte): 'sube' | 'baja' | 'varia' | null{
    const numeros = indicador.valores.filter(v => !!v).map(v => Number(v.valor));
    if(numeros.length < 2){
      return null;
    }
    const diferencias = numeros.slice(1).map((n, i) => n - numeros[i]);
    if(diferencias.every(d => d >= 0) && diferencias.some(d => d > 0)){
      return 'sube';
    }
    if(diferencias.every(d => d <= 0) && diferencias.some(d => d < 0)){
      return 'baja';
    }
    return 'varia';
  }

  /**
   * Costos y rendimientos: margen de intermediación, gastos totales operativos, gastos administrativos, gastos de gobernabilidad,
   * ROA y rendimiento del capital. Cifras de la norma fijas en el texto (92%, 10%, 7%, 1% y 7%), como en el Word.
   */
  private armarTextosCostosRendimientos(){
    const bloque = this.bloquesDatos[2];
    if(!bloque || this.columnasBalance.length === 0){
      return;
    }
    const columnas = this.columnasBalance;
    const ultima = columnas.length - 1;
    const periodo = columnas[ultima].nombre;
    const buscar = (condicion: (descripcion: string) => boolean) =>
      bloque.indicadores.find(i => condicion(this.normalizar(i.descripcion)));
    const colorUltimo = (i: IndicadorReporte) => this.colorFrase(i.valores[ultima]?.semaforo);

    const margen = buscar(d => d.includes('margen') && d.includes('intermediacion'));
    const operativos = buscar(d => d.includes('gastos totales operativos'));
    const administrativos = buscar(d => d.includes('gastos administrativos'));
    const gobernabilidad = buscar(d => d.includes('gobernabilidad'));
    const roa = buscar(d => d.includes('rendimiento') && d.includes('activo'));
    const capital = buscar(d => d.includes('rendimiento del capital'));

    const textos: string[] = [];

    if(margen && colorUltimo(margen)){
      textos.push(this.t('indicadores-margen', {
        parametros: this.t(`indicadores-margen-${colorUltimo(margen)}`),
        alcance: this.alcanceIndicador(margen, 'indicadores-alcance-todos-presentados'),
      }));
    }

    if(operativos && colorUltimo(operativos)){
      const sentido = this.sentidoIndicador(operativos);
      textos.push(this.t(sentido ? 'indicadores-gastos-operativos' : 'indicadores-gastos-operativos-sin-tendencia', {
        tendencia: sentido ? this.t(`indicadores-tendencia-${sentido}`) : '',
        periodo,
        valor: operativos.valores[ultima]?.valor,
        posicion: this.t(`indicadores-gastos-operativos-${colorUltimo(operativos)}`),
      }));
    }

    if(administrativos && colorUltimo(administrativos)){
      textos.push(this.t('indicadores-administrativos', {
        ubicacion: this.t(`indicadores-administrativos-ubicacion-${colorUltimo(administrativos)}`),
        periodo,
        valor: administrativos.valores[ultima]?.valor,
        verbo: this.t(`indicadores-administrativos-verbo-${colorUltimo(administrativos)}`),
      }));
    }

    if(gobernabilidad && colorUltimo(gobernabilidad)){
      textos.push(this.t('indicadores-gobernabilidad', {
        posicion: this.t(`indicadores-gobernabilidad-${colorUltimo(gobernabilidad)}`),
        valor: gobernabilidad.valores[ultima]?.valor,
        alcance: this.alcanceIndicador(gobernabilidad, 'indicadores-alcance-todos-presentan'),
      }));
    }

    if(roa && colorUltimo(roa)){
      const primero = roa.valores.findIndex(v => !!v);
      const sentido = this.sentidoIndicador(roa);
      textos.push(this.t(sentido ? 'indicadores-roa' : 'indicadores-roa-sin-evolucion', {
        evolucion: sentido ? this.t(`indicadores-roa-${sentido}`) : '',
        inicial: roa.valores[primero]?.valor,
        desde: columnas[primero].nombre,
        final: roa.valores[ultima]?.valor,
        hasta: periodo,
        posicion: this.t(`indicadores-roa-posicion-${colorUltimo(roa)}`),
      }));
    }

    if(capital && colorUltimo(capital)){
      textos.push(this.t('indicadores-capital', {
        periodo,
        valor: capital.valores[ultima]?.valor,
        relacion: this.t(`indicadores-capital-relacion-${colorUltimo(capital)}`),
        cumple: this.t(`indicadores-capital-cumple-${colorUltimo(capital)}`),
      }));
    }
    this.textosBloques[2] = textos;
  }

  /**
   * Liquidez: índice de liquidez, disponibilidades inmediatas y concentración de depósitos en entidades financieras y en centrales
   * o bancos de propiedad cooperativa. Si el valor del último periodo de una concentración es 0, dice que no cuenta con esos depósitos.
   */
  private armarTextosLiquidez(){
    const bloque = this.bloquesDatos[3];
    if(!bloque || this.columnasBalance.length === 0){
      return;
    }
    const ultima = this.columnasBalance.length - 1;
    const periodo = this.columnasBalance[ultima].nombre;
    const buscar = (condicion: (descripcion: string) => boolean) =>
      bloque.indicadores.find(i => condicion(this.normalizar(i.descripcion)));
    const colorUltimo = (i: IndicadorReporte) => this.colorFrase(i.valores[ultima]?.semaforo);
    const valor = (i: IndicadorReporte, decimales = 2) => this.formatoNumero(Number(i.valores[ultima]?.valor), decimales);
    const sinDepositos = (i: IndicadorReporte) => !!i.valores[ultima] && Number(i.valores[ultima].valor) === 0;

    const liquidez = buscar(d => d.includes('indice de liquidez'));
    const disponibilidades = buscar(d => d.includes('disponibilidades'));
    const entidades = buscar(d => d.includes('entidades financieras'));
    const centrales = buscar(d => d.includes('centrales'));

    const textos: string[] = [];

    if(liquidez && colorUltimo(liquidez)){
      const color = colorUltimo(liquidez);
      const exceso = Number(liquidez.valores[ultima]?.valor) > 20;
      const frase = color === 'rojo' ? 'incumple' : (color === 'amarillo' && exceso ? 'productivos' : 'cumple');
      textos.push(this.t('indicadores-liquidez', {
        color: this.t(`indicadores-color-${color}`),
        // Si el color cambió entre periodos no se repite el periodo, que ya va junto al valor
        alcance: this.mismoColorEnPeriodos(liquidez) ? ` ${this.t('indicadores-alcance-todos')}` : '',
        valor: valor(liquidez),
        periodo,
        frase: this.t(`indicadores-liquidez-${frase}`),
      }));
    }

    if(disponibilidades && colorUltimo(disponibilidades)){
      textos.push(this.t('indicadores-disponibilidades', {
        proporcion: this.t(`indicadores-disponibilidades-${colorUltimo(disponibilidades)}`),
        valor: valor(disponibilidades),
      }));
    }

    if(entidades && colorUltimo(entidades)){
      textos.push(sinDepositos(entidades)
        ? this.t('indicadores-concentracion-entidades-cero')
        : this.t('indicadores-concentracion-entidades', { nivel: this.t(`indicadores-concentracion-${colorUltimo(entidades)}`), valor: valor(entidades) }));
    }

    if(centrales && colorUltimo(centrales)){
      textos.push(sinDepositos(centrales)
        ? this.t('indicadores-concentracion-centrales-cero')
        : this.t('indicadores-concentracion-centrales', { nivel: this.t(`indicadores-concentracion-${colorUltimo(centrales)}`), valor: valor(centrales) }));
    }
    this.textosBloques[3] = textos;
  }

  /**
   * Calidad de activos: morosidad (tendencia contra el periodo anterior), financiamiento de activos improductivos con patrimonio
   * y límite de crédito por socio. Cifras de la norma fijas en el texto (100% y 15%), como en el Word.
   */
  private armarTextosCalidadActivos(){
    const bloque = this.bloquesDatos[4];
    if(!bloque || this.columnasBalance.length === 0){
      return;
    }
    const columnas = this.columnasBalance;
    const ultima = columnas.length - 1;
    const periodo = columnas[ultima].nombre;
    const buscar = (condicion: (descripcion: string) => boolean) =>
      bloque.indicadores.find(i => condicion(this.normalizar(i.descripcion)));
    const colorUltimo = (i: IndicadorReporte) => this.colorFrase(i.valores[ultima]?.semaforo);

    const morosidad = buscar(d => d.includes('morosidad'));
    const improductivos = buscar(d => d.includes('financiamiento') && d.includes('improductivos'));
    const creditoSocio = buscar(d => d.includes('credito') && d.includes('socio'));

    const textos: string[] = [];

    if(morosidad && morosidad.valores[ultima]){
      const actual = Number(morosidad.valores[ultima].valor);
      const anterior = ultima > 0 ? morosidad.valores[ultima - 1] : null;
      textos.push(anterior
        ? this.t('indicadores-morosidad', {
          tendencia: this.t(actual >= Number(anterior.valor) ? 'indicadores-tendencia-sube' : 'indicadores-tendencia-baja'),
          valor: morosidad.valores[ultima].valor,
          periodo,
          anterior: anterior.valor,
        })
        : this.t('indicadores-morosidad-sin-anterior', { valor: morosidad.valores[ultima].valor, periodo }));
    }

    if(improductivos && colorUltimo(improductivos)){
      textos.push(this.t(`indicadores-improductivos-${colorUltimo(improductivos)}`, {
        valor: this.formatoNumero(Number(improductivos.valores[ultima]?.valor), 2),
      }));
    }

    if(creditoSocio && colorUltimo(creditoSocio)){
      textos.push(this.t('indicadores-credito-socio', {
        verbo: this.t(`indicadores-credito-verbo-${colorUltimo(creditoSocio)}`),
        color: this.t(`indicadores-color-${colorUltimo(creditoSocio)}`),
        alcance: this.t(this.mismoColorEnPeriodos(creditoSocio) ? 'indicadores-alcance-para-todos' : 'indicadores-alcance-para-ultimo'),
      }));
    }
    this.textosBloques[4] = textos;
  }

  /**
   * Indicador referencial: índice de activos improductivos. El texto cita fija la referencia de la norma (12%), como en el Word; la
   * plantilla tiene otros límites (verde hasta 10% y rojo desde 15%), por eso amarillo dice "cercano" y no "inferior" o "superior".
   */
  private armarTextosIndicadorReferencial(){
    const bloque = this.bloquesDatos[5];
    if(!bloque || this.columnasBalance.length === 0){
      return;
    }
    const ultima = this.columnasBalance.length - 1;
    const indicador = bloque.indicadores.find(i => this.normalizar(i.descripcion).includes('improductivos'));
    const color = indicador ? this.colorFrase(indicador.valores[ultima]?.semaforo) : null;
    if(!indicador || !color){
      return;
    }
    this.textosBloques[5] = [this.t('indicadores-referencial', {
      color: this.t(`indicadores-color-${color}`),
      // Si el color cambió entre periodos no se repite el periodo, que ya va junto al valor
      alcance: this.mismoColorEnPeriodos(indicador) ? ` ${this.t('indicadores-alcance-evaluados')}` : '',
      valor: indicador.valores[ultima]?.valor,
      periodo: this.columnasBalance[ultima].nombre,
      relacion: this.t(`indicadores-referencial-relacion-${color}`),
      niveles: this.t(`indicadores-referencial-niveles-${color}`),
    })];
  }

  /**
   * Costo financiero fuentes de fondeo: costo total de los pasivos (valor, referencia de 8% y tendencia) y desglose por fuente.
   * La fuente más costosa del último periodo va primero con su color; las demás se agrupan por color, y las que valen 0 se
   * declaran sin costo. Una fuente ascendente se destaca con su tendencia.
   */
  private armarTextosCostoFondeo(){
    const bloque = this.bloquesDatos[6];
    if(!bloque || this.columnasBalance.length === 0){
      return;
    }
    const ultima = this.columnasBalance.length - 1;
    const periodo = this.columnasBalance[ultima].nombre;
    const buscar = (condicion: (descripcion: string) => boolean) =>
      bloque.indicadores.find(i => condicion(this.normalizar(i.descripcion)));
    const colorUltimo = (i: IndicadorReporte) => this.colorFrase(i.valores[ultima]?.semaforo);
    const textos: string[] = [];

    const total = buscar(d => d.includes('costo total') && d.includes('pasivos'));
    if(total && colorUltimo(total)){
      const sentido = this.sentidoIndicador(total);
      textos.push(this.t('fondeo-total', {
        valor: total.valores[ultima]?.valor,
        periodo,
        posicion: this.t(`fondeo-total-${colorUltimo(total)}`),
        alcance: this.mismoColorEnPeriodos(total) ? ` ${this.t('indicadores-alcance-todos')}` : '',
        tendencia: sentido ? this.t('fondeo-tendencia', { tendencia: this.t(`indicadores-tendencia-${sentido}`) }) : '',
      }));
    }

    const fuentes = [
      { clave: 'plazo', indicador: buscar(d => d.includes('plazo fijo')) },
      { clave: 'vista', indicador: buscar(d => d.includes('vista')) },
      { clave: 'externo', indicador: buscar(d => d.includes('externo')) },
      { clave: 'otras', indicador: buscar(d => d.includes('otras captaciones')) },
    ].filter(fuente => !!fuente.indicador && !!fuente.indicador.valores[ultima] && !!colorUltimo(fuente.indicador))
      .map(fuente => ({ ...fuente, valor: Number(fuente.indicador.valores[ultima].valor), color: colorUltimo(fuente.indicador) }));

    const conCosto = fuentes.filter(f => f.valor > 0);
    const sinCosto = fuentes.filter(f => f.valor === 0);
    const nombre = (clave: string) => this.t(`fondeo-fuente-${clave}`);
    const cifra = (f: typeof fuentes[number]) => `${nombre(f.clave)} (${f.indicador.valores[ultima].valor}%)`;

    const clausulas: string[] = [];
    if(conCosto.length > 0){
      const mayor = conCosto.reduce((a, b) => b.valor > a.valor ? b : a);
      const resto = conCosto.filter(f => f !== mayor);
      clausulas.push(this.t(this.mismoColorEnPeriodos(mayor.indicador) ? 'fondeo-mayor-todos' : 'fondeo-mayor-ultimo', {
        fuente: cifra(mayor),
        color: this.t(`indicadores-color-${mayor.color}`),
        periodo,
      }));
      const colores = [...new Set(resto.map(f => f.color))];
      colores.forEach((color, i) => {
        const grupo = resto.filter(f => f.color === color);
        const ascendentes = grupo.filter(f => this.sentidoIndicador(f.indicador) === 'sube');
        let ascenso = '';
        if(ascendentes.length === 1 && grupo[grupo.length - 1] === ascendentes[0] && grupo.length > 1){
          ascenso = this.t('fondeo-ultimo-ascendente');
        }else if(ascendentes.length > 0){
          ascenso = this.t('fondeo-ascendente', { fuentes: this.enumerar(ascendentes.map(f => nombre(f.clave))) });
        }
        clausulas.push(this.t(i === 0 ? 'fondeo-resto-primero' : 'fondeo-resto-siguiente', {
          fuentes: this.enumerar(grupo.map(cifra)),
          verbo: this.t(grupo.length > 1 ? 'costos-verbo-plural' : 'costos-verbo-singular'),
          color: this.t(`indicadores-color-${color}`),
          ascenso,
        }));
      });
    }
    const partes: string[] = [];
    if(clausulas.length > 0){
      partes.push(this.t('fondeo-por-fuente', { detalle: clausulas.join('; ') }));
    }
    if(sinCosto.length > 0){
      partes.push(this.t('fondeo-sin-costo', { fuentes: this.enumerar(sinCosto.map(f => this.t(`fondeo-fuente-sin-${f.clave}`))) }));
    }
    if(partes.length > 0){
      textos.push(partes.join(' '));
    }
    this.textosBloques[6] = textos;
  }

  public claseSemaforo(semaforo: string | undefined): string{
    return semaforo ? (this.clasesSemaforo[semaforo] ?? '') : '';
  }

  /**
   * Cascada del estado de resultados en % de los ingresos financieros: parte de los ingresos (100%), resta costos, previsiones y gastos,
   * suma comisiones netas hasta el excedente operativo, y de ahí suma otros ingresos y resta otros gastos hasta el resultado del ejercicio.
   * Cada total (ingresos, excedente y resultado) arranca de cero con su % reportado, así que el redondeo no se arrastra.
   */
  private armarGraficaCostos(){
    const ultima = this.columnasBalance.length - 1;
    let acumulado = 0;
    this.cascadaCostos = this.pasosCostos
      .map(paso => ({ ...paso, fila: this.filasEstado.find(f => f.id === paso.id) }))
      .filter(paso => !!paso.fila && paso.fila.valores[ultima] !== null)
      .map(paso => {
        const porcentaje = paso.fila.porcentajes[ultima];
        if(paso.tipo === 'total'){
          acumulado = porcentaje;
          return { nombre: paso.fila.descripcion, tipo: paso.tipo, valor: porcentaje, desde: 0, hasta: porcentaje };
        }
        const valor = paso.tipo === 'resta' ? -porcentaje : porcentaje;
        const desde = acumulado;
        acumulado += valor;
        return { nombre: paso.fila.descripcion, tipo: paso.tipo, valor, desde, hasta: acumulado };
      });
    // Sin los ingresos como punto de partida la cascada no tiene sentido
    const completa = this.cascadaCostos.length > 1 && this.filasEstado.some(f => f.id === this.pasosCostos[0].id);
    this.graficaCostos = completa
      ? {
        data: [{ name: this.t('estructura-costos'), data: this.cascadaCostos.map(paso => paso.valor) }],
        labels: this.cascadaCostos.map(paso => paso.nombre),
        totales: this.cascadaCostos.flatMap((paso, i) => paso.tipo === 'total' ? [i] : []),
      }
      : { data: [], labels: [], totales: [] };
    this.armarTextosCostos();
    this.armarTendenciaCostos();
  }

  /**
   * Opciones de ApexCharts de la cascada para el PDF (la vista previa la dibuja el graficador con el tipo WATERFALL): barras flotantes
   * (rangeBar) en tres series que se encimen en una columna por cuenta. La etiqueta con el % va sobre la barra (debajo si es un total
   * negativo) y en rojo si es negativa. La letra va grande porque la imagen se reduce al ancho de la hoja.
   */
  private opcionesCascadaCostosPDF(){
    // Apex descarta un rango cuyo extremo es exactamente 0, por eso se usa un valor casi cero
    const sinCero = (valor: number) => valor === 0 ? 1e-6 : valor;
    const claveSerie = (paso: PasoCascada) => paso.tipo === 'total' ? 'costos-serie-total' : paso.valor >= 0 ? 'costos-serie-aumento' : 'costos-serie-disminucion';
    const etiqueta = (paso: PasoCascada) => {
      const redondeado = Math.round(paso.valor) || 0;
      return `${paso.tipo !== 'total' && redondeado >= 0 ? '+' : ''}${this.formatoNumero(redondeado)}%`;
    };
    const series = ['costos-serie-aumento', 'costos-serie-disminucion', 'costos-serie-total'].map(clave => ({
      name: this.t(clave),
      data: this.cascadaCostos.map(paso => ({
        x: paso.nombre,
        y: claveSerie(paso) === clave ? [sinCero(Math.min(paso.desde, paso.hasta)), sinCero(Math.max(paso.desde, paso.hasta))] : null,
      })),
    }));
    const puntos = this.cascadaCostos.map(paso => {
      // Un total negativo es una barra que cuelga de cero: la etiqueta va debajo
      const debajo = paso.tipo === 'total' && paso.valor < 0;
      return {
        x: paso.nombre,
        y: debajo ? Math.min(paso.desde, paso.hasta) : Math.max(paso.desde, paso.hasta),
        marker: { size: 0 },
        label: {
          text: etiqueta(paso),
          borderWidth: 0,
          offsetY: debajo ? 30 : -6,
          style: { background: 'transparent', color: paso.valor < 0 ? this.rojoNegativo : '#333333', fontSize: '17px', fontWeight: 700, fontFamily: this.fuentePDF },
        },
      };
    });
    // Margen arriba y abajo para que las etiquetas no queden fuera del área de la gráfica
    const extremos = this.cascadaCostos.flatMap(paso => [paso.desde, paso.hasta]);
    const alto = Math.max(0, ...extremos);
    const bajo = Math.min(0, ...extremos);
    const margen = ((alto - bajo) || 1) * 0.15;
    // El eje salta de 20 en 20 (de 10 en 10 si el rango es corto) y arranca y termina en múltiplos del salto; igual que en la vista previa
    const limiteInferior = bajo < 0 ? bajo - margen : 0;
    const limiteSuperior = alto + margen;
    const salto = limiteSuperior - limiteInferior > 60 ? 20 : 10;
    const minEje = Math.floor(limiteInferior / salto) * salto;
    const maxEje = Math.ceil(limiteSuperior / salto) * salto;
    // Nombres en hasta 3 líneas de unos 14 caracteres para que no se encimen entre barras
    const partirNombre = (nombre: string) => {
      const lineas: string[] = [];
      for(const palabra of nombre.split(' ')){
        const ultima = lineas.length - 1;
        if(ultima >= 0 && `${lineas[ultima]} ${palabra}`.length <= 14){
          lineas[ultima] = `${lineas[ultima]} ${palabra}`;
        }else{
          lineas.push(palabra);
        }
      }
      return lineas.length > 3 ? [...lineas.slice(0, 2), `${lineas.slice(2).join(' ').substring(0, 13)}…`] : lineas;
    };
    return {
      series,
      chart: { type: 'rangeBar' },
      colors: [this.colorMulti[1], this.colorMulti[2], this.colorMulti[0]],
      plotOptions: { bar: { horizontal: false, columnWidth: '70%', rangeBarGroupRows: true } },
      dataLabels: { enabled: false },
      annotations: { points: puntos },
      grid: { borderColor: '#E0E0E0' },
      xaxis: {
        type: 'category',
        labels: { rotate: 0, trim: false, maxHeight: 130, formatter: (valor: any) => typeof valor === 'string' ? partirNombre(valor) : valor, style: { fontSize: '15px', fontFamily: this.fuentePDF } },
      },
      yaxis: {
        min: minEje,
        max: maxEje,
        tickAmount: Math.round((maxEje - minEje) / salto),
        labels: { formatter: (valor: number) => `${Math.round(valor)}%`, style: { fontSize: '16px', fontFamily: this.fuentePDF } },
      },
      legend: { position: 'bottom', fontSize: '18px', fontFamily: this.fuentePDF, itemMargin: { horizontal: 14, vertical: 2 } },
    };
  }

  /** Palabra de la estructura de costos y del excedente según el % del excedente operativo (regla del Excel). */
  private nivelExcedente(porcentaje: number){
    if(porcentaje > 5){
      return { estado: 'equilibrada', excedente: 'holgado' };
    }
    return porcentaje > 0 ? { estado: 'ligera', excedente: 'muy-bajo' } : { estado: 'desequilibrada', excedente: 'negativo' };
  }

  /**
   * Tendencia de costos sobre ingresos financieros: columnas apiladas con el % de cada cuenta de costo por periodo,
   * y el texto con el resultado operativo, el periodo anterior, los gastos operativos totales y la cuenta que más creció.
   */
  private armarTendenciaCostos(){
    this.textosTendenciaCostos = [];
    const columnas = this.columnasBalance;
    const cuentas = this.idsCostosTendencia
      .map(id => this.filasEstado.find(f => f.id === id))
      .filter(f => !!f);
    this.graficaTendenciaCostos = {
      data: cuentas.map(f => ({ name: f.descripcion, data: f.porcentajes.map(p => Number(p.toFixed(2))) })),
      labels: columnas.map(c => c.titulo),
    };
    const excedente = this.filasEstado.find(f => f.id === this.idExcedente);
    if(columnas.length < 2 || cuentas.length === 0 || !excedente){
      return;
    }
    const ultima = columnas.length - 1;
    const anterior = ultima - 1;
    const resultado = excedente.porcentajes[ultima];
    const crecimientos = cuentas.map(f => ({
      nombre: f.descripcion.toLowerCase(),
      crecimiento: f.porcentajes[ultima] - f.porcentajes[anterior],
      antes: f.porcentajes[anterior],
      ahora: f.porcentajes[ultima],
    }));
    const mayor = [...crecimientos].sort((a, b) => b.crecimiento - a.crecimiento)[0];

    const texto = this.t('tendencia-costos-texto', {
      estado: this.t(`costos-estado-${this.nivelExcedente(resultado).estado}`),
      periodo: columnas[ultima].nombre,
      resultado: this.formatoNumero(resultado, 1),
      sentido: this.t(resultado < excedente.porcentajes[anterior] ? 'tendencia-costos-disminuye' : 'tendencia-costos-incrementa'),
      anterior: this.formatoNumero(excedente.porcentajes[anterior], 1),
      totales: this.formatoNumero(cuentas.reduce((suma, f) => suma + f.porcentajes[anterior], 0), 1),
    });
    this.textosTendenciaCostos.push(mayor.crecimiento > 0
      ? `${texto} ${this.t('tendencia-costos-mayor', { cuenta: mayor.nombre, antes: this.formatoNumero(mayor.antes, 1), ahora: this.formatoNumero(mayor.ahora, 1) })}`
      : texto);
  }

  /**
   * Texto de estructura de costos: cuentas de costo de mayor a menor saldo, su % sobre los ingresos financieros y el total.
   * La palabra de la estructura y la del excedente salen del % del excedente operativo (equilibrada / holgado por encima de 5%,
   * ligeramente desequilibrada / muy bajo de 0% a 5%, desequilibrada / negativo en 0% o menos).
   */
  private armarTextosCostos(){
    this.textosCostos = [];
    if(this.columnasBalance.length === 0){
      return;
    }
    const ultima = this.columnasBalance.length - 1;
    const periodo = this.columnasBalance[ultima].nombre;
    const costos = this.filasEstado
      .filter(f => this.idsCostos.includes(f.id) && f.valores[ultima] !== null)
      .map(f => ({ nombre: f.descripcion.toLowerCase(), saldo: f.valores[ultima] as number, porcentaje: f.porcentajes[ultima] }))
      .sort((a, b) => b.saldo - a.saldo);
    const excedente = this.filasEstado.find(f => f.id === this.idExcedente);
    if(costos.length === 0 || !excedente){
      return;
    }

    // Artículo según la terminación del nombre ("los gastos…", "las previsiones…"); sin artículo si no se reconoce
    const articulo = (nombre: string) => {
      const palabra = nombre.split(' ')[0];
      return /(as|ones)$/.test(palabra) ? 'las' : /os$/.test(palabra) ? 'los' : '';
    };
    const conArticulo = (nombre: string) => `${articulo(nombre)} ${nombre}`.trim();

    let detalleSaldos = '';
    costos.forEach((c, i) => {
      const clave = i === 0 ? 'mayor' : i === 1 ? 'posterior' : i === costos.length - 1 ? 'final' : 'seguido';
      const clausula = this.t(`costos-${clave}`, {
        cuenta: i === 0 ? c.nombre : conArticulo(c.nombre),
        saldo: this.formatoNumero(c.saldo),
        verbo: this.t(articulo(c.nombre) ? 'costos-verbo-plural' : 'costos-verbo-singular'),
      });
      detalleSaldos += i === 0 ? clausula : `${i === 1 ? '; ' : ' '}${clausula}`;
    });
    this.textosCostos.push(this.t('costos-texto-saldos', { periodo, detalle: detalleSaldos }));

    const porcentajeExcedente = excedente.porcentajes[ultima];
    const { estado: nivel, excedente: excedenteTexto } = this.nivelExcedente(porcentajeExcedente);
    this.textosCostos.push(this.t('costos-texto-base100', {
      detalle: this.enumerar(costos.map(c => this.t('costos-porcentaje', { cuenta: conArticulo(c.nombre), porcentaje: this.formatoNumero(c.porcentaje, 1) }))),
      total: this.formatoNumero(costos.reduce((suma, c) => suma + c.porcentaje, 0), 1),
      estado: this.t(`costos-estado-${nivel}`),
      excedente: this.t(`costos-excedente-${excedenteTexto}`),
    }));

    const { ingresos, gastos, resultado } = this.idsOtros;
    const filaResultado = this.filasEstado.find(f => f.id === resultado);
    const filaIngresos = this.filasEstado.find(f => f.id === ingresos);
    const filaGastos = this.filasEstado.find(f => f.id === gastos);
    if(filaResultado && filaIngresos && filaGastos){
      const valorResultado = filaResultado.valores[ultima] ?? 0;
      this.textosCostos.push(this.t('costos-texto-resultado', {
        signo: this.t(valorResultado >= 0 ? 'costos-resultado-positivo' : 'costos-resultado-negativo'),
        resultado: this.formatoNumero(valorResultado),
        otrosIngresos: this.formatoNumero(filaIngresos.valores[ultima]),
        otrosIngresosPorcentaje: this.formatoNumero(filaIngresos.porcentajes[ultima], 1),
        otrosGastos: this.formatoNumero(filaGastos.valores[ultima]),
        otrosGastosPorcentaje: this.formatoNumero(filaGastos.porcentajes[ultima], 1),
      }));
    }
  }

  /** "a, b y c" con la conjunción traducida. */
  private enumerar(elementos: string[]): string{
    if(elementos.length <= 1){
      return elementos.join('');
    }
    return `${elementos.slice(0, -1).join(', ')} ${this.t('tendencia-y')} ${elementos[elementos.length - 1]}`;
  }

  /**
   * Texto de activos (fila nivel 1 "Activo") y de cartera de crédito neta (VT005): variación entre el primer y el último periodo
   * y el porcentaje de cada par de periodos consecutivos.
   */
  private armarTextosTendencia(){
    this.textosTendencia = [];
    const columnas = this.columnasBalance;
    if(columnas.length < 2){
      return;
    }
    const ultima = columnas.length - 1;
    const activo = this.filasTendencia.find(f => f.nivel === 1);
    const cartera = this.filasTendencia.find(f => f.id === this.idsProductivos.cartera);
    const total = (f: { valores: (number | null)[] }) => (f.valores[ultima] ?? 0) - (f.valores[0] ?? 0);
    const pares = (f: typeof activo, clave: (v: { valor: number | null; porcentaje: number }) => string) =>
      f.variaciones.map((v, i) => this.t(clave(v), {
        porcentaje: this.formatoNumero(v.porcentaje),
        desde: columnas[i].nombre,
        hasta: columnas[i + 1].nombre,
      }));

    if(activo){
      const variacion = total(activo);
      const base = activo.valores[0] ?? 0;
      this.textosTendencia.push(this.t('tendencia-activo', {
        desde: columnas[0].nombre,
        hasta: columnas[ultima].nombre,
        sentido: this.t(variacion >= 0 ? 'tendencia-incremento' : 'tendencia-decremento'),
        total: this.formatoNumero(Math.abs(variacion)),
        porcentaje: this.formatoNumero(base === 0 ? 0 : (Math.abs(variacion) / Math.abs(base)) * 100, 1),
        detalle: this.enumerar(pares(activo, () => 'tendencia-activo-par')),
      }));
    }
    if(cartera){
      const variacion = total(cartera);
      this.textosTendencia.push(this.t('tendencia-cartera', {
        periodo: columnas[ultima].nombre,
        saldo: this.formatoNumero(cartera.valores[ultima]),
        tendencia: this.t(variacion >= 0 ? 'tendencia-alza' : 'tendencia-baja'),
        variacion: this.formatoNumero(variacion),
        detalle: this.enumerar(pares(cartera, v => (v.valor ?? 0) >= 0 ? 'tendencia-cartera-incremento' : 'tendencia-cartera-disminucion')),
      }));
    }
  }

  public graficaVisible(g: { bandera: 'activoA' | 'pasivoA' | 'patrimonioA' }): boolean{
    return this.balanceEstructuraA && this[g.bandera];
  }

  private async consultar(query: any, variables: any, campo: string): Promise<any[]>{
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query,
        context: { headers: this.headers },
        variables
      }).valueChanges.source
    );
    return data[campo];
  }

  /** Mismas cuentas, orden y niveles que el balance de estados financieros; solo se regresan los niveles 1 y 2. */
  private async obtenerFilasBalance(columnas: { id: number; titulo: string; nombre: string }[]){
    const idPlantilla = this.idPlantilla;
    const estructura = ObtenerIds[`idsCuentasP${idPlantilla}`]('', 'bal', true);

    const [cuentas, variables, varsTemp] = await Promise.all([
      this.consultar(getCuentas, { idPlantilla }, 'cuentas'),
      this.consultar(getVars, { idPlantilla }, 'variables'),
      this.consultar(getVarsTemp, { idPlantilla }, 'varsTemp'),
    ]);
    const descripciones = new Map<string, string>();
    [...cuentas, ...variables, ...varsTemp].forEach(c => descripciones.set(c.id, c.descripcion));

    const valoresPorColumna = await Promise.all(columnas.map(async col => {
      const idEvaluacion = col.id;
      const [c, v, t] = await Promise.all([
        this.consultar(getDetalleEvaluacionCuenta, { idEvaluacion }, 'detalleEvaluacionCuentas'),
        this.consultar(getDetalleEvaluacionVars, { idEvaluacion }, 'detalleEvaluacionVariables'),
        this.consultar(getDetalleEvaluacionVarTemp, { idEvaluacion }, 'detalleEvaluacionVarsTemps'),
      ]);
      const mapa = new Map<string, number>();
      c.forEach(d => mapa.set(d.idCuenta, d.valor));
      v.forEach(d => mapa.set(d.idVariable, d.valor));
      t.forEach(d => mapa.set(d.idVarTemp, d.valor));
      return mapa;
    }));

    const armarFilas = (estructuraCuentas: any): FilaCuenta[] => {
      const lista: FilaCuenta[] = Object.keys(estructuraCuentas)
        .map(id => ({ id, nivel: estructuraCuentas[id][0].nivel as number, pos: estructuraCuentas[id][0].pos as number }))
        .sort((a, b) => a.pos - b.pos)
        .filter(f => valoresPorColumna.some(m => m.has(f.id)))
        .map(f => ({
          id: f.id,
          descripcion: this.capitalizar(descripciones.get(f.id) ?? f.id),
          nivel: f.nivel,
          valores: valoresPorColumna.map(m => m.has(f.id) ? Number(m.get(f.id)) : null),
          porcentajes: [] as number[],
        }));
      lista.forEach((fila, i) => {
        fila.porcentajes = fila.valores.map((valor, j) => this.porcentajeVertical(lista, valor ?? 0, j, i));
      });
      return lista;
    };

    const filas = armarFilas(estructura);
    // Estado de resultados: misma evaluación, con la estructura 'est' de la plantilla
    const estructuraEstado = ObtenerIds[`idsCuentasP${idPlantilla}`]('', 'est', true);
    const estado = estructuraEstado ? armarFilas(estructuraEstado) : [];
    const ids = Object.values(this.idsCartera);
    const cartera = filas
      .filter(f => ids.includes(f.id))
      .map(f => ({ id: f.id, descripcion: f.descripcion, valores: f.valores }));
    return { filas: filas.filter(f => f.nivel <= 2), cartera, estado: estado.filter(f => f.nivel <= 2) };
  }

  /** Porcentaje sobre el total del activo (niveles 1 y 2) o sobre la cuenta padre (niveles inferiores). */
  private porcentajeVertical(filas: { nivel: number; valores: (number | null)[] }[], monto: number, columna: number, indice: number): number{
    const nivel = filas[indice].nivel;
    let base = 0;
    if(nivel !== 1 && nivel !== 2 && this.idPlantilla !== 12){
      for(let i = indice; i >= 0; i--){
        if(filas[i].nivel < nivel){
          base = filas[i].valores[columna] ?? 0;
          break;
        }else if(i === 0){
          base = filas[i].valores[columna] ?? 0;
        }
      }
    }else{
      base = filas[0].valores[columna] ?? 0;
    }
    const porcentaje = base === 0 ? 0 : (monto / base) * 100;
    return Number.isNaN(porcentaje) ? 0 : porcentaje;
  }

  private capitalizar(texto: string): string{
    if(!texto){
      return '';
    }
    const resto = texto.substring(1).toLowerCase();
    return texto.substring(0, 1).toUpperCase() + (resto.endsWith('.') ? resto.slice(0, -1) : resto);
  }

  private formatoNumero(valor: number | null, decimales = 0): string{
    return valor === null ? '' : this.numero.transform(valor, decimales, this.miles, this.decimal);
  }

  /* ---------------------------------- PDF ---------------------------------- */
  public async generarPDF(){
    try{
      this.descargando = true;
      messages.messageSaving(this.translate.instant('acciones.descarga'), this.translate.instant('acciones.espera'));

      const fechaPiePag = new Date().toLocaleDateString('es-MX', { month: '2-digit', day: '2-digit', year: '2-digit' });
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;
      const graficasEstructura = await this.graficasEstructuraPDF();
      const graficaCartera = await this.graficaCarteraPDF();
      const graficaCostos = await this.graficaCostosPDF();
      const graficaTendenciaCostos = await this.graficaTendenciaCostosPDF();

      const docPDF = {
        pageSize: 'A4',
        pageMargins: [40, 100, 40, 60],
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
          logoHeader: ConstantesImagenes.logoHeader,
          coverWave: ConstantesImagenes.coverWave,
        },
        defaultStyle: {
          font: 'Roboto',
          fontSize: 11
        },
        header: function (currentPage){
          if(currentPage == 1){
            return null;
          }
          return {
            columns: [
              {
                image: 'logoHeader',
                width: 20,
                alignment: 'left',
                margin: [40, 30, 0, 0],
              },
              { text: '', width: '*' },
            ]
          };
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return {
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },
                {
                  text: currentPage.toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            };
          }
          return {
            text: {
              text: currentPage.toString(),
              alignment: 'right',
              color: '#808080',
              fontSize: 10,
              width: 'auto',
            }, margin: [10, -1, 30, 0],
          };
        },
        content: [
          this.portadaPDF(),
          { text: '', pageBreak: 'after' },
          this.tablaContenidoPDF(),
          { text: '', pageBreak: 'after' },
          this.introduccionPDF(),
          this.balanceEstructuraPDF(graficasEstructura),
          this.balanceTendenciaPDF(graficaCartera),
          this.estadoResultadosPDF(graficaCostos, graficaTendenciaCostos),
          this.indicadoresPDF(),
          this.conclusionesPDF(),
        ]
      };

      const pdf = pdfMake.createPdf(docPDF);
      await pdf.download('Reporte financiero');

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'));
    }catch(error){
      Swal.close();
      Swal.fire({ title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000 });
    }finally{
      this.descargando = false;
    }
  }

  private readonly rojoNegativo = '#D32F2F';
  /**
   * Letra de las gráficas del PDF. La imagen se arma con el SVG de ApexCharts, que solo ve las letras instaladas: con "Roboto" a secas,
   * cada texto puede caer en una letra distinta (con serifas) según el peso. La pila con sans-serif de respaldo mantiene todo igual.
   */
  private readonly fuentePDF = 'Roboto, Helvetica, Arial, sans-serif';
  private readonly cachePartes = new Map<string, { texto: string; negativo: boolean }[]>();

  /**
   * Parte un texto en tramos para pintar de rojo los montos y porcentajes negativos ("G -716,851,968", "-5%").
   * Se guarda en caché por texto para no recalcular en cada ciclo de la vista.
   */
  public partesTexto(texto: string): { texto: string; negativo: boolean }[]{
    const guardado = this.cachePartes.get(texto);
    if(guardado){
      return guardado;
    }
    const partes: { texto: string; negativo: boolean }[] = [];
    const patron = /(?:G\s)?-\d+(?:,\d{3})*(?:\.\d+)?%?/g;
    let ultimo = 0;
    let coincidencia = patron.exec(texto);
    while(coincidencia !== null){
      const inicio = coincidencia.index;
      // un guion pegado a una palabra o número ("2023-2024") no es un signo menos
      if(!(inicio > 0 && /\w/.test(texto[inicio - 1]))){
        if(inicio > ultimo){
          partes.push({ texto: texto.slice(ultimo, inicio), negativo: false });
        }
        partes.push({ texto: coincidencia[0], negativo: true });
        ultimo = inicio + coincidencia[0].length;
      }
      coincidencia = patron.exec(texto);
    }
    if(ultimo < texto.length){
      partes.push({ texto: texto.slice(ultimo), negativo: false });
    }
    this.cachePartes.set(texto, partes);
    return partes;
  }

  private t(clave: string, params?: any): string{
    return this.translate.instant(`financiero.reporte.${clave}`, params);
  }

  private lineaPDF(){
    return {
      canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#000000' }],
      margin: [0, 5, 0, 20]
    };
  }

  private tituloPDF(texto: string, saltoDeHoja = false, id?: string){
    return [
      {
        text: texto,
        ...(saltoDeHoja ? { pageBreak: 'before' } : {}),
        ...(id ? { id } : {}),
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#000000',
        margin: [0, 30, 0, 0],
      },
      this.lineaPDF(),
    ];
  }

  private subtituloPDF(texto: string, id?: string){
    return { text: texto, ...(id ? { id } : {}), bold: true, fontSize: 12, color: '#000000', margin: [0, 15, 0, 8] };
  }

  private parrafoPDF(texto: string, resaltarNegativos = true, tamano = 11){
    const contenido = resaltarNegativos
      ? this.partesTexto(texto).map(p => p.negativo ? { text: p.texto, color: this.rojoNegativo } : p.texto)
      : texto;
    return { text: contenido, alignment: 'justify', fontSize: tamano, color: '#000000', margin: [0, 0, 0, 10] };
  }

  /** Ancho en puntos de un texto con la letra del PDF (Roboto), para calcular los puntos guía del índice. */
  private medirTexto(texto: string, tamano: number, negrita: boolean): number{
    const contexto = document.createElement('canvas').getContext('2d');
    contexto.font = `${negrita ? 500 : 400} ${tamano}px Roboto`;
    return contexto.measureText(texto).width;
  }

  /** Entradas del índice: solo las secciones que están en el reporte, con el id del encabezado al que apuntan. */
  private entradasIndicePDF(): { nivel: 1 | 2; etiqueta: string; id: string }[]{
    const entrada = (nivel: 1 | 2, clave: string, id: string) => ({ nivel, etiqueta: this.t(clave), id });
    return [
      entrada(1, 'indice-analisis-financiero', 'indice-analisis'),
      ...(this.balanceEstructuraA || this.balanceTendenciaA ? [entrada(2, 'indice-balance-general', 'indice-balance')] : []),
      ...(this.estadoResultadosA ? [entrada(2, 'indice-estado-resultados', 'indice-estado')] : []),
      ...(this.estadoResultadosA && this.estructuraCostosA ? [entrada(2, 'indice-estructura-costos', 'indice-costos')] : []),
      ...(this.indicadoresA ? [entrada(1, 'indice-indicadores', 'indice-indicadores')] : []),
      ...(this.indicadoresA ? this.bloquesIndicadores.filter(b => b.activo).map(b => ({ nivel: 2 as const, etiqueta: this.t(b.clave), id: `indice-${b.clave}` })) : []),
      ...(this.conclusionesA && this.textoConclusiones !== '' ? [entrada(1, 'indice-conclusiones', 'indice-conclusiones')] : []),
    ];
  }

  /**
   * Índice de dos niveles: las secciones principales van en negrita, las subsecciones van sangradas, y cada
   * renglón lleva puntos guía hasta el número de la hoja. El número lo pone pdfmake (pageReference) y coincide con el del pie de página.
   * Los puntos se calculan midiendo el texto con Roboto para que lleguen hasta el número sin pasarse.
   */
  private tablaContenidoPDF(){
    const entradas = this.entradasIndicePDF();
    const tamano = 11;
    const sangria = 18;
    const anchoNumero = 32;
    const relleno = 4;
    // 515 pt de hoja, menos la columna del número y el relleno de las dos celdas, menos un margen de seguridad
    const interior = 515 - anchoNumero - relleno * 4 - 10;
    const puntoAncho = this.medirTexto('.', tamano, false);
    const filas = entradas.map(entrada => {
      const negrita = entrada.nivel === 1;
      const izquierda = entrada.nivel === 2 ? sangria : 0;
      const usado = izquierda + this.medirTexto(`${entrada.etiqueta} `, tamano, negrita);
      const puntos = Math.max(0, Math.floor((interior - usado) / puntoAncho) - 1);
      return [
        {
          text: [{ text: entrada.etiqueta, bold: negrita }, { text: ` ${'.'.repeat(puntos)}`, color: '#9E9E9E' }],
          noWrap: true,
          margin: [izquierda, 0, 0, 0],
          linkToDestination: entrada.id,
        },
        { text: '', pageReference: entrada.id, alignment: 'right', bold: negrita },
      ];
    });
    return [
      {
        text: this.t('indice-titulo'),
        style: 'header',
        bold: true,
        fontSize: 18,
        color: this.azulNivel1,
        margin: [0, 40, 0, 20],
      },
      {
        table: { widths: ['*', anchoNumero], body: filas },
        layout: {
          hLineWidth: () => 0,
          vLineWidth: () => 0,
          paddingLeft: () => relleno,
          paddingRight: () => relleno,
          paddingTop: () => 4,
          paddingBottom: () => 4,
        },
        fontSize: tamano,
        color: '#333333',
      },
    ];
  }

  private portadaPDF(){
    return [
      {
        image: 'coverWave',
        width: 595,
        height: 170,
        absolutePosition: { x: 0, y: 671.89 },
      },
      {
        image: 'logoHeader',
        width: 110,
        absolutePosition: { x: 242.64, y: 187 },
      },
      {
        text: this.nombreInstitucion,
        style: 'header',
        bold: true,
        fontSize: 26,
        color: '#000000',
        alignment: 'right',
        margin: [0, 252, 0, 0],
      },
      {
        text: this.t('portada-1'),
        style: 'header',
        bold: true,
        fontSize: 20,
        color: '#000000',
        alignment: 'right',
        margin: [0, 45, 0, 0],
      },
      {
        text: `${this.t('portada-3')} ${this.periodoTexto}`,
        style: 'header',
        bold: true,
        fontSize: 14,
        color: '#949393',
        alignment: 'right',
        margin: [0, 2, 0, 0],
      },
      {
        text: this.t('portada-2'),
        style: 'header',
        bold: true,
        fontSize: 18,
        color: '#000000',
        alignment: 'right',
        margin: [0, 25, 0, 0],
      },
      {
        text: this.t('aviso-legal', this.parametrosReporte),
        style: 'header',
        bold: false,
        fontSize: 8,
        color: '#000000',
        width: 495,
        absolutePosition: { x: 60, y: 610 },
      },
    ];
  }

  private introduccionPDF(){
    return [
      this.tituloPDF(this.t('portada-1')),
      this.parrafoPDF(this.t('introduccion', this.parametrosReporte)),
      this.tituloPDF(this.t(this.claveTituloAnalisis, this.parametrosReporte).toUpperCase(), false, 'indice-analisis'),
      this.parrafoPDF(this.t(this.claveIntroAnalisis, this.parametrosReporte)),
    ];
  }

  /** Imagen de cada dona visible, en el mismo orden que `graficasEstructura`; las ocultas quedan como null. */
  private async graficasEstructuraPDF(){
    const imagenes: (string | null)[] = [];
    for(const g of this.graficasEstructura){
      imagenes.push(this.graficaVisible(g) ? await this.imagenDonaPDF(g) : null);
    }
    return imagenes;
  }

  /**
   * Dibuja una gráfica fuera de pantalla con ApexCharts y devuelve su imagen. El tamaño del lienzo y de la letra se eligen para el PDF:
   * la imagen se reduce al ancho de la hoja, así que la letra se dibuja grande para que quede legible.
   * La resolución se logra con el tamaño del lienzo; la opción `scale` de dataURI dibuja el contenido en un solo cuadrante.
   */
  private async imagenGraficaPDF(opciones: any, ancho: number, alto: number): Promise<string>{
    const contenedor = document.createElement('div');
    contenedor.style.cssText = `position: fixed; left: -10000px; top: 0; width: ${ancho}px; background: #ffffff;`;
    document.body.appendChild(contenedor);
    const grafica = new ApexCharts(contenedor, {
      tooltip: { enabled: false },
      ...opciones,
      chart: { width: ancho, height: alto, background: '#ffffff', fontFamily: this.fuentePDF, animations: { enabled: false }, toolbar: { show: false }, ...opciones.chart },
    });
    try{
      await grafica.render();
      const resultado: any = await grafica.dataURI();
      return resultado.imgURI;
    }finally{
      grafica.destroy();
      contenedor.remove();
    }
  }

  private imagenDonaPDF(g: { data: any[]; labels: string[] }): Promise<string>{
    return this.imagenGraficaPDF({
      chart: { type: 'donut' },
      series: g.data[0].data,
      labels: g.labels,
      colors: this.colorMulti,
      stroke: { show: false },
      plotOptions: { pie: { donut: { size: '50%' } } },
      dataLabels: {
        enabled: true,
        formatter: (valor: number) => `${valor.toFixed(1)}%`,
        style: { fontSize: '28px', fontWeight: 600, fontFamily: this.fuentePDF, colors: ['#FFFFFF'] },
        dropShadow: { enabled: false },
      },
      legend: { position: 'bottom', fontSize: '22px', fontFamily: this.fuentePDF, itemMargin: { horizontal: 12, vertical: 4 } },
    }, 960, 680);
  }

  /** 1 250 000 000 -> "1 Mil M"; 45 000 000 -> "45 M" (misma abreviatura que usan las gráficas del tablero). */
  private montoAbreviado(valor: number): string{
    const absoluto = Math.abs(valor);
    const signo = valor < 0 ? '-' : '';
    if(absoluto >= 1_000_000_000){
      return `${signo}${this.formatoNumero(absoluto / 1_000_000_000, 0)} Mil M`;
    }
    if(absoluto >= 1_000_000){
      return `${signo}${this.formatoNumero(absoluto / 1_000_000, 0)} M`;
    }
    return this.formatoNumero(valor);
  }

  /**
   * Barras agrupadas de cartera bruta vigente, mora y previsiones como % de la cartera total, con la etiqueta sobre cada barra
   * y sin eje Y. Las usan la vista previa y el PDF; en el PDF la letra va más grande porque la imagen se reduce al ancho de la hoja.
   */
  private opcionesBarrasCartera(pdf: boolean){
    const letra = (pantalla: number, hoja: number) => `${pdf ? hoja : pantalla}px`;
    return {
      series: this.graficaCartera.data,
      chart: pdf ? { type: 'bar' } : { type: 'bar', height: 380, toolbar: { show: false }, fontFamily: this.fuentePDF },
      colors: this.colorMulti,
      plotOptions: { bar: { columnWidth: '75%', borderRadius: 2, dataLabels: { position: 'top' } } },
      dataLabels: {
        enabled: true,
        formatter: (valor: number) => `${this.formatoNumero(valor, 1)}%`,
        offsetY: pdf ? -22 : -18,
        style: { fontSize: letra(12, 16), fontFamily: this.fuentePDF, colors: ['#333333'] },
      },
      grid: { show: false },
      xaxis: { categories: this.graficaCartera.labels, labels: { style: { fontSize: letra(13, 18), fontFamily: this.fuentePDF } } },
      yaxis: { show: false, min: 0 },
      legend: { position: 'bottom', fontSize: letra(13, 18), fontFamily: this.fuentePDF, itemMargin: { horizontal: 14, vertical: 2 } },
      ...(pdf ? {} : { tooltip: { y: { formatter: (valor: number) => `${this.formatoNumero(valor, 1)}%` } } }),
    };
  }

  /**
   * Imagen de las barras de cartera para el PDF. El lienzo es 1000 x 300 (unos 515 x 155 pt en la hoja): es bajo a propósito para que el
   * título y la gráfica quepan en lo que suele sobrar de la hoja después de los textos de tendencia, en vez de pasar solos a la siguiente.
   */
  private imagenCarteraPDF(): Promise<string>{
    return this.imagenGraficaPDF(this.opcionesBarrasCartera(true), 1000, 300);
  }

  /** Dona de un lado y texto del otro, como en la plantilla; el lado se alterna entre activo, pasivo y patrimonio. */
  private bloqueDonaPDF(g: { clave: string; dona: 'izquierda' | 'derecha'; textos: string[] }, imagen: string){
    // El título va arriba de la dona, del lado donde esté la gráfica
    const dona = {
      width: 280,
      stack: [
        { ...this.subtituloPDF(this.t(g.clave)), margin: [0, 8, 0, 4], alignment: g.dona === 'derecha' ? 'right' : 'left' },
        { image: imagen, width: 280 },
      ],
    };
    const texto = {
      width: '*',
      stack: g.textos.map(t => this.parrafoPDF(t)),
      margin: g.dona === 'izquierda' ? [15, 50, 0, 0] : [0, 50, 15, 0],
    };
    return { columns: g.dona === 'izquierda' ? [dona, texto] : [texto, dona], columnGap: 10 };
  }

  private balanceEstructuraPDF(graficas: (string | null)[]){
    if(!this.balanceEstructuraA){
      return [];
    }
    return [
      this.subtituloPDF(this.t('bg-estructura-titulo'), 'indice-balance'),
      this.parrafoPDF(this.t('bg-estructura-def')),
      this.tablaBalancePDF(),
      // Las tres donas van juntas: si no caben en lo que queda de la hoja, pasan completas a la siguiente
      { stack: this.graficasEstructura.map((g, i) => graficas[i] ? this.bloqueDonaPDF(g, graficas[i] as string) : []), unbreakable: true },
    ];
  }

  private tablaBalancePDF(filasTabla: FilaCuenta[] = this.filasBalance, conCodigo = false){
    if(filasTabla.length === 0){
      return [];
    }
    const base = { fontSize: 7.5, color: this.colorTexto };
    const encabezado = [
      ...(conCodigo ? [{ ...base, text: this.translate.instant('financiero.catalogoCuentas.encabezado1Tabla1'), bold: true, color: this.colorEncabezado, alignment: 'center', fillColor: this.fondoEncabezado, borderColor: this.bordeEncabezado }] : []),
      { ...base, text: this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1'), bold: true, color: this.colorEncabezado, alignment: 'center', fillColor: this.fondoEncabezado, borderColor: this.bordeEncabezado },
      ...this.columnasBalance.flatMap(c => [
        { ...base, text: c.titulo, bold: true, color: this.colorEncabezado, alignment: 'left', fillColor: this.fondoEncabezado, borderColor: this.bordeEncabezado },
        { ...base, text: '%', bold: true, color: this.azulNivel1, alignment: 'center', fillColor: this.fondoEncabezado, borderColor: this.bordeEncabezado },
      ]),
    ];
    const cuerpo = filasTabla.map(f => {
      const principal = f.nivel === 1;
      const relleno = principal ? '#EDEDED' : '#F9F9F9';
      return [
        ...(conCodigo ? [{ ...base, text: f.id, bold: principal, fillColor: relleno }] : []),
        { ...base, text: f.descripcion, bold: principal, fillColor: relleno, margin: [(f.nivel - 1) * 8, 0, 0, 0] },
        ...f.valores.flatMap((v, j) => [
          { ...base, text: this.formatoNumero(v), bold: principal, noWrap: true, alignment: 'right', fillColor: relleno },
          { ...base, text: v === null ? '' : `${this.formatoNumero(f.porcentajes[j])} %`, bold: true, noWrap: true, color: principal ? this.azulNivel1 : this.azulNivel2, alignment: 'center', fillColor: relleno },
        ]),
      ];
    });
    return {
      table: {
        headerRows: 1,
        widths: [...(conCodigo ? ['auto'] : []), '*', ...this.columnasBalance.flatMap(() => ['auto', 'auto'])],
        body: [encabezado, ...cuerpo],
      },
      layout: this.layoutTablaBalance(1),
      margin: [0, 0, 0, 20],
    };
  }

  /** Bordes como en la vista previa: encabezado separado por líneas blancas y cuerpo con líneas grises claras. */
  private layoutTablaBalance(filasEncabezado: number, relleno = 4, columnasSinRelleno: number[] = []){
    return {
      hLineWidth: (i: number) => i === 0 ? 0 : 0.75,
      vLineWidth: () => 1,
      hLineColor: (i: number, nodo: any) => i === nodo.table.body.length ? '#B9B9BC' : (i <= filasEncabezado ? '#FFFFFF' : '#E0E0E0'),
      vLineColor: () => '#E0E0E0',
      paddingLeft: (i: number) => columnasSinRelleno.includes(i) ? 0 : relleno,
      paddingRight: (i: number) => columnasSinRelleno.includes(i) ? 0 : relleno,
      paddingTop: () => relleno / 2,
      paddingBottom: () => relleno / 2,
    };
  }

  private async graficaCarteraPDF(){
    if(!this.balanceTendenciaA || !this.carteraNetaA || this.graficaCartera.data.length === 0){
      return null;
    }
    // Ancho útil de la hoja A4 con márgenes de 40: 515 pt
    return { image: await this.imagenCarteraPDF(), width: 515, alignment: 'center', margin: [0, 0, 0, 16] };
  }

  private balanceTendenciaPDF(graficaCartera: any){
    if(!this.balanceTendenciaA){
      return [];
    }
    return [
      // Hoja horizontal de la tabla de tendencias: título, definición, tabla y sus textos. Con letra de 10 los textos caben debajo
      // de una tabla de hasta 20 filas; con más filas pasan a una segunda hoja horizontal.
      { stack: [
        this.subtituloPDF(this.t('bg-tendencia-titulo'), this.balanceEstructuraA ? undefined : 'indice-balance'),
        this.parrafoPDF(this.t('bg-tendencia-def')),
        this.tablaTendenciaPDF(),
        ...this.textosTendencia.map(texto => this.parrafoPDF(texto, true, 10)),
      ], pageBreak: 'before', pageOrientation: 'landscape' },
      // Lo que sigue vuelve a la hoja vertical
      { text: '', pageBreak: 'before', pageOrientation: 'portrait' },
      ...(this.carteraNetaA ? [
        { stack: [this.subtituloPDF(this.t('cartera-neta')), ...(graficaCartera ? [graficaCartera] : [])], unbreakable: true },
        ...this.textosCartera.map(texto => this.parrafoPDF(texto)),
      ] : []),
    ];
  }

  /** Hasta 11 columnas en hoja horizontal: con más periodos se reduce un poco la letra para que quepan la tabla y sus textos. */
  private tablaTendenciaPDF(){
    if(this.filasTendencia.length === 0 || this.paresTendencia.length === 0){
      return [];
    }
    const totalPeriodos = this.columnasBalance.length;
    const base = { fontSize: totalPeriodos > 4 ? 6.5 : 7, color: this.colorTexto, noWrap: true };
    const encabezadoBase = { ...base, bold: true, color: this.colorEncabezado, fillColor: this.fondoEncabezado, borderColor: this.bordeEncabezado };

    const encabezadoPares = [
      { ...base, text: '', colSpan: totalPeriodos + 1, fillColor: '#FFFFFF', borderColor: this.bordeEncabezado },
      ...Array(totalPeriodos).fill({}),
      ...this.paresTendencia.flatMap(par => [
        { ...encabezadoBase, text: par, alignment: 'center', colSpan: 2, noWrap: false, fillColor: '#E0E1E3' },
        {},
      ]),
    ];
    const encabezado = [
      { ...encabezadoBase, text: this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1'), alignment: 'center' },
      ...this.columnasBalance.map(c => ({ ...encabezadoBase, text: c.titulo, alignment: 'left' })),
      ...this.paresTendencia.flatMap(() => [
        { ...encabezadoBase, text: this.t('tendencia-variacion'), color: this.azulNivel1, alignment: 'center' },
        { ...encabezadoBase, text: '%', color: this.azulNivel1, alignment: 'center' },
      ]),
    ];
    const cuerpo = this.filasTendencia.map(f => {
      const principal = f.nivel === 1;
      const relleno = principal ? '#EDEDED' : '#F9F9F9';
      return [
        { ...base, text: f.descripcion, bold: principal, noWrap: false, fillColor: relleno, margin: [(f.nivel - 1) * 8, 0, 0, 0] },
        ...f.valores.map(v => ({ ...base, text: this.formatoNumero(v), bold: principal, alignment: 'right', fillColor: relleno })),
        ...f.variaciones.flatMap(v => [
          { ...base, text: this.formatoNumero(v.valor), bold: true, color: principal ? this.azulNivel1 : this.azulNivel2, alignment: 'right', fillColor: relleno },
          { ...base, text: v.valor === null ? '' : `${this.formatoNumero(v.porcentaje)} %`, bold: true, color: principal ? this.azulNivel1 : this.azulNivel2, alignment: 'center', fillColor: relleno },
        ]),
      ];
    });
    return {
      table: {
        headerRows: 2,
        dontBreakRows: true,
        widths: ['*', ...this.columnasBalance.map(() => 'auto'), ...this.paresTendencia.flatMap(() => ['auto', 'auto'])],
        body: [encabezadoPares, encabezado, ...cuerpo],
      },
      layout: this.layoutTablaBalance(2, 3),
      margin: [0, 0, 0, 20],
    };
  }

  private async graficaCostosPDF(){
    if(!this.estadoResultadosA || !this.estructuraCostosA || this.graficaCostos.data.length === 0){
      return null;
    }
    // Ancho útil de la hoja A4 con márgenes de 40: 515 pt
    return { image: await this.imagenCostosPDF(), width: 515, alignment: 'center', margin: [0, 0, 0, 16] };
  }

  /** Cascada de estructura de costos para el PDF. El lienzo es 1000 x 420 (unos 515 x 216 pt en la hoja). */
  private imagenCostosPDF(): Promise<string>{
    return this.imagenGraficaPDF(this.opcionesCascadaCostosPDF(), 1000, 420);
  }

  private async graficaTendenciaCostosPDF(){
    if(!this.estadoResultadosA || !this.tendenciaCostosA || this.graficaTendenciaCostos.data.length === 0){
      return null;
    }
    // Ancho útil de la hoja A4 con márgenes de 40: 515 pt
    return { image: await this.imagenTendenciaCostosPDF(), width: 515, alignment: 'center', margin: [0, 0, 0, 16] };
  }

  /**
   * Columnas apiladas en valor real (%): la altura de cada columna es el total de costos sobre ingresos financieros (puede pasar de 100%).
   * Cada segmento lleva su %, el total va arriba de la columna y el eje salta de 20 en 20 (de 10 en 10 si el rango es corto), como la vista previa.
   */
  private imagenTendenciaCostosPDF(): Promise<string>{
    const datos = this.graficaTendenciaCostos.data;
    const totales = this.graficaTendenciaCostos.labels.map((_, i) => datos.reduce((suma, serie) => suma + (Number(serie.data[i]) || 0), 0));
    const puntos = this.graficaTendenciaCostos.labels.map((categoria, i) => ({
      x: categoria,
      y: totales[i],
      marker: { size: 0 },
      label: {
        text: `${this.t('costos-serie-total')} ${this.formatoNumero(totales[i])}%`,
        borderWidth: 0,
        offsetY: -6,
        style: { background: 'transparent', color: '#333333', fontSize: '18px', fontWeight: 700, fontFamily: this.fuentePDF },
      },
    }));
    const alto = Math.max(0, ...totales);
    const margen = (alto || 1) * 0.15;
    const salto = alto + margen > 60 ? 20 : 10;
    const maxEje = Math.ceil((alto + margen) / salto) * salto;
    return this.imagenGraficaPDF({
      chart: { type: 'bar', stacked: true, stackType: 'normal' },
      series: datos,
      colors: this.colorMulti,
      plotOptions: { bar: { horizontal: false, columnWidth: '45%' } },
      dataLabels: {
        enabled: true,
        formatter: (valor: number) => `${this.formatoNumero(valor)}%`,
        style: { fontSize: '18px', fontWeight: 700, fontFamily: this.fuentePDF, colors: ['#FFFFFF'] },
        dropShadow: { enabled: false },
      },
      annotations: { points: puntos },
      grid: { borderColor: '#E0E0E0' },
      xaxis: { categories: this.graficaTendenciaCostos.labels, labels: { style: { fontSize: '18px', fontFamily: this.fuentePDF } } },
      yaxis: { min: 0, max: maxEje, tickAmount: Math.round(maxEje / salto), labels: { formatter: (valor: number) => `${this.formatoNumero(valor)}%`, style: { fontSize: '16px', fontFamily: this.fuentePDF } } },
      legend: { position: 'bottom', fontSize: '18px', fontFamily: this.fuentePDF, itemMargin: { horizontal: 14, vertical: 2 } },
    }, 1000, 420);
  }

  private estadoResultadosPDF(graficaCostos: any, graficaTendenciaCostos: any){
    if(!this.estadoResultadosA){
      return [];
    }
    return [
      this.subtituloPDF(this.t('er-estructura-titulo'), 'indice-estado'),
      this.parrafoPDF(this.t('er-estructura-def', this.parametrosReporte)),
      this.tablaBalancePDF(this.filasEstado, true),
      ...(this.estructuraCostosA
        ? [
          { stack: [this.subtituloPDF(this.t('estructura-costos'), 'indice-costos'), ...(graficaCostos ? [graficaCostos] : [])], unbreakable: true },
          // El texto sigue a la gráfica en la misma hoja; si no cabe, pdfmake lo pasa a la siguiente
          ...this.textosCostos.map(texto => this.parrafoPDF(texto)),
        ]
        : []),
      ...(this.tendenciaCostosA ? [
        { stack: [
          this.subtituloPDF(this.t('tendencia-costos')),
          this.parrafoPDF(this.t('tendencia-costos-def')),
          ...(graficaTendenciaCostos ? [graficaTendenciaCostos] : []),
        ], unbreakable: true },
        ...this.textosTendenciaCostos.map(texto => this.parrafoPDF(texto)),
      ] : []),
    ];
  }

  private indicadoresPDF(){
    if(!this.indicadoresA){
      return [];
    }
    return [
      // La sección B empieza en hoja nueva para que su tabla no quede cortada
      this.tituloPDF(this.t('indicadores-titulo'), true, 'indice-indicadores'),
      this.parrafoPDF(this.t('indicadores-intro')),
      this.tablaLimitesPDF(),
      // Título, definición y tabla de cada bloque juntos, para que la tabla no se parta entre hojas
      ...this.bloquesIndicadores.flatMap((b, i) => b.activo ? [{
        stack: [
          this.subtituloPDF(this.t(b.clave), `indice-${b.clave}`),
          ...(b.definicion ? [this.parrafoPDF(this.t(`${b.clave}-def`))] : []),
          this.tablaBloquePDF(this.bloquesDatos[i]),
        ],
        unbreakable: true,
      }, ...(this.textosBloques[i] ?? []).map(texto => this.parrafoPDF(texto))] : []),
    ];
  }

  /** Celda de encabezado de un límite: círculo con el color del semáforo y el nombre del color. */
  private encabezadoLimitePDF(limite: ColumnaLimite, base: any){
    return {
      ...base,
      columns: [
        { width: '*', text: '' },
        { width: 9, canvas: [{ type: 'ellipse', x: 4, y: 5, r1: 3.5, r2: 3.5, color: limite.color }] },
        { width: 'auto', text: limite.titulo, bold: true, color: this.colorEncabezado, fontSize: base.fontSize },
        { width: '*', text: '' },
      ],
    };
  }

  /** Tabla general: descripción y límites por color (verde, amarillo y rojo) de cada indicador, agrupados por bloque. */
  private tablaLimitesPDF(){
    if(this.bloquesDatos.length === 0){
      return [];
    }
    const base = { fontSize: 7, color: this.colorTexto };
    const encabezadoBase = { ...base, fillColor: this.fondoEncabezado, borderColor: this.bordeEncabezado };
    const limites = this.columnasLimites;
    const encabezado = [
      { ...encabezadoBase, text: this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1'), bold: true, color: this.colorEncabezado, alignment: 'center' },
      ...limites.map(l => this.encabezadoLimitePDF(l, encabezadoBase)),
    ];
    const cuerpo = this.bloquesDatos.flatMap(b => [
      [{ ...base, text: b.descripcion.toUpperCase(), bold: true, colSpan: encabezado.length, fillColor: '#EDEDED' }, ...Array(encabezado.length - 1).fill({})],
      ...b.indicadores.map(i => [
        { ...base, text: i.descripcion, fillColor: '#F9F9F9', margin: [(i.nivel - 2) * 8, 0, 0, 0] },
        ...limites.map(l => ({ ...base, text: i.limites[l.clave], alignment: 'center', fillColor: '#F9F9F9' })),
      ]),
    ]);
    return {
      table: { headerRows: 1, dontBreakRows: true, widths: ['*', ...limites.map(() => 110)], body: [encabezado, ...cuerpo] },
      layout: this.layoutTablaBalance(1),
      margin: [0, 0, 0, 20],
    };
  }

  /** Tabla de un bloque: límites por color, valor de cada periodo y una franja con el color del semáforo. */
  private tablaBloquePDF(bloque: BloqueIndicadores | undefined){
    if(!bloque || bloque.indicadores.length === 0){
      return [];
    }
    const base = { fontSize: 7, color: this.colorTexto };
    const encabezadoBase = { ...base, bold: true, color: this.colorEncabezado, fillColor: this.fondoEncabezado, borderColor: this.bordeEncabezado };
    const limites = this.columnasLimites;
    const periodos = this.columnasBalance;

    const encabezado = [
      { ...encabezadoBase, text: this.translate.instant('financiero.catalogoCuentas.encabezado2Tabla1'), alignment: 'center' },
      ...limites.map(l => this.encabezadoLimitePDF(l, encabezadoBase)),
      ...periodos.flatMap(p => [{ ...encabezadoBase, text: p.titulo, alignment: 'center', colSpan: 2 }, {}]),
    ];
    const anchoLimite = 62;
    const columnasMarcador = periodos.map((_, i) => 1 + limites.length + i * 2 + 1);
    const cuerpo = [
      [
        { ...base, text: bloque.descripcion.toUpperCase(), bold: true, colSpan: encabezado.length - 0, fillColor: '#EDEDED' },
        ...Array(encabezado.length - 1).fill({}),
      ],
      ...bloque.indicadores.map(i => [
        { ...base, text: i.descripcion, fillColor: '#F9F9F9', margin: [(i.nivel - 2) * 8, 0, 0, 0] },
        ...limites.map(l => ({ ...base, text: i.limites[l.clave], alignment: 'center', fillColor: '#F9F9F9' })),
        ...i.valores.flatMap(v => [
          { ...base, text: v ? v.valor : '', alignment: 'right', fillColor: '#F9F9F9' },
          { ...base, text: '', fillColor: v ? (this.coloresSemaforo[v.semaforo] ?? '#F9F9F9') : '#F9F9F9' },
        ]),
      ]),
    ];
    return {
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: ['*', ...limites.map(() => anchoLimite), ...periodos.flatMap(() => ['auto', 5])],
        body: [encabezado, ...cuerpo],
      },
      layout: this.layoutTablaBalance(1, 4, columnasMarcador),
      margin: [0, 0, 0, 20],
    };
  }

  private conclusionesPDF(){
    if(!this.conclusionesA || this.textoConclusiones === ''){
      return [];
    }
    return [
      this.tituloPDF(this.t('conclusiones-titulo'), false, 'indice-conclusiones'),
      this.parrafoPDF(this.textoConclusiones, false),
    ];
  }
}
